import { Box, Button, Checkbox, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, Modal, Tab, Tabs } from "@mui/material";
import { format } from "date-fns";
import React, { useEffect, useMemo, useState } from "react";
import { useForm } from "react-hook-form";
import { useLocation } from "react-router-dom";
import CommonButton from "../../../../common/components/Buttons/CommonButton";
import CommonBackDrop from "../../../../common/components/CommonBackDrop/CommonBackDrop";
import CommonTransactionPaginationTable from "../../../../common/components/CommonTable/CommonTransactionPaginationTable";
import CommonTransactionTable from "../../../../common/components/CommonTable/CommonTransactionTable";
import ConfirmationModal from "../../../../common/components/ConfirmationModal";
// import { useGetUserActions } from "../../../../common/components/Custom Hooks/useGetUserActions";
import RadioField from "../../../../common/components/FormFields/RadioField";
import SearchDropdown from "../../../../common/components/FormFields/searchDropdown";
import { Controller } from "react-hook-form";
import {
  errorAlert,
  successAlert,
  warningAlert,
} from "../../../../common/components/Toasts/CustomToasts";
import {
  autoSearchCssdItemKit,
  autoSearchCssdItemItem,
  getItemsinItemKitById,
  deletecleaningwrappingItem,
} from "../../../services/commonservices/commonservices";
import {
  getStoreDropdown,
  autoSearchSurgeonName,
  autoSearchHandoverReceived,
} from "../../../services/commonservices/commonservices";
import {
  fetchTransferCssdItemsKitListCSSDRe,
  fetchTransferCssdItemsList,
  getBatchWiseCssdKits,
  getItemWiseBatchNoDropdown,
  saveTransferCssdItemsParentList,
  getBatchwiseItemsForKit,
} from "../../../services/transferReceiveCssdServices/TransferReceiveCssdServices";

import SearchBar from "../../../../common/components/FormFields/SearchBar";
import DatePickerField from "../../../../common/components/FormFields/DatePickerFieldNew";
import DropdownField from "../../../../common/components/FormFields/DropdownField";
import { CloseModalIcon } from "../../../../common/components/assets/commonassets/CommonAssets";
import { ModalStyle } from "../../../../common/components/modalstyle/ModalStyle";
import TableDropDownField from "../../../../common/components/FormFields/TableDropDownField";
import { UseCheckConsecutiveCharacters } from "../../../../common/components/Custom Hooks/UseCheckConsecutiveCharacters";
import { id } from "date-fns/locale";
import { useNavigate } from "react-router-dom";
import { DeleteIcon } from "../../../../assets/CommonAssets";

const itemType = [
  { label: "Kit", value: "Kit", id: "Kit" },
  { label: "Item", value: "Item", id: "Item" },
];

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}
const DecontaminationAndCleaning = (props) => {
  const { setView } = props;
  const location = useLocation();
  const getUserInfo = JSON.parse(localStorage?.getItem("loggedUser"));
  const [cleaningItemsList, setCleaningItemsList] = useState([]);
  const [cleaningKitList, setCleaningKitList] = useState([]);
  const [cleaningKitItemsList, setCleaningKitItemsList] = useState([]);
  const [page, setPage] = useState(0);
  const [kitPage, setKitPage] = useState(0);
  const [selectedProcess, setSelectedProcess] = useState("wrapping");
  const [formData, setFormData] = useState({});
  const { getValues, reset } = useForm();
  const [finalTabs, setFinalTabs] = useState([]);
  const [manualUpdate, setManualUpdate] = useState(false);
  const [surgeonSearch, setSurgeonSearch] = useState("");
  const [selectedOption, setSelectedOption] = useState(null);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [kitRowsPerPage, setKitRowsPerPage] = useState(10);
  const [count, setCount] = useState(null);
  const [kitCount, setKitCount] = useState(null);
  const [openPostModal, setOpenPostModal] = useState(false);
  const [openBackdrop, setOpenBackdrop] = useState(false);
  const [userActions, setUserActions] = useState([]);
  const [itemKitOptions, setItemKitOptions] = useState([]);
  const [modalItemKitOptions, setModalItemKitOptions] = useState([]);
  const [modalItemItemOptions, setModalItemItemOptions] = useState([]);
  const [activeType, setActiveType] = useState("kit");
  const [addType, setAddType] = useState("kit"); // "kit" or "item"
  const [surgeonOptions, setSurgeonOptions] = useState([]);
  const [handoverOptions, setHandoverOptions] = useState([]);
  const [receivedOptions, setReceivedOptions] = useState([]);
  const [selectedKit, setSelectedKit] = useState(null);
  const [groupedItems, setGroupedItems] = useState({});
  const [transferReceiveItemsList, setTransferReceiveItemsList] = useState([]);
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [openModel, setOpenModel] = useState(false);
  const [pendingRow, setPendingRow] = useState(null);


  // const [activeKitId, setActiveKitId] = useState(null);

  const [kitListingObject, setKitListingObject] = useState({
    searchString: "",
    searchId: null,
    fromDate: null,
    toDate: null,
    page: page,
    size: rowsPerPage,
  });
  const [storeOptions, setStoreOptions] = useState([]);
  const [openKitModal, setOpenAddKitModal] = useState(false);
  const [newKitBatch, setNewKitBatch] = useState("");
  const [existKitBatch, setExistKitBatch] = useState("");
  const [values, setValues] = useState(null);
  const [searchBarId, setSearchBarId] = useState(null);
  const [searchBarString, setSearchBarString] = useState("");

  const handleChange = (event, newValue) => {
    setValues(newValue);
  };

  console.log("newKitBatch", newKitBatch, "existKitBatch", existKitBatch);

  const defaultValues = {
    fromDate: null,
    toDate: null,
    itemType: "Kit",
    fromStore: null,
    addKitItemSearch: null,
  };
  const {
    control,
    watch,
    setError,
    clearErrors,
    setValue,
    register,
    formState: { errors },
  } = useForm({
    mode: "onChange",
    defaultValues: defaultValues,
  });

  const navigate = useNavigate();

  const handleProcessClick = (processType) => {
    // You can also save processType in context/state if needed
    navigate(`/WrappingAndPackaging?process=${processType}`);
  };

  let getFromDate = watch("fromDate");
  let getToDate = watch("toDate");
  let getItemType = watch("itemType");
  let getStore = watch("fromStore");

  let getAddKitItemSearch = watch("addKitItemSearch");

  const populateItemTable = (forPagination) => {
    let listObj = {
      searchString: "",
      searchId: null,
      fromDate: null,
      toDate: null,
      page: !forPagination ? 0 : page,
      size: rowsPerPage,
      processType: "cleaning",
      kitId: null,
    };
    console.log("listObj:", listObj);
    console.log("id:", listObj?.id, "kitBatchNo:", listObj?.kitBatchNo);

    fetchTransferCssdItemsList(listObj.id, listObj.kitBatchNo).then((response) => {

      if (forPagination) {
        setCleaningItemsList((prevData) => [
          ...prevData,
          ...response.data.result?.map((val) => ({
            Select: true,
            "Item Code": val?.["Item Code"],
            "Item Name": val?.["ItemName"],
            ...val,
            "Cleaned Qty": val?.["Receive Qty"],
            "Old Cleaned Qty": val?.["Receive Qty"],
            "Disposed Qty": val?.["Disposed Qty"],
            "Disposed Reason": val?.["Disposed Reason"],
          })),
        ]);
      } else {
        setCleaningItemsList(
          response.data.result?.map((val) => ({
            Select: true,
            "Item Code": val?.["Item Code"],
            "Item Name": val?.["ItemName"],
            ...val,
            "Cleaned Qty": val?.["Receive Qty"],
            "Old Cleaned Qty": val?.["Receive Qty"],
            "Disposed Qty": val?.["Disposed Qty"],
            "Disposed Reason": val?.["Disposed Reason"],
          }))
        );
        setPage(0);
      }
      setCount(response.data.count);
    });
  };


  const populateKitTable = (forPagination) => {
    let listObj = {
      searchString: kitListingObject?.searchString,
      searchId: kitListingObject?.searchId,
      fromDate: kitListingObject?.fromDate,
      toDate: kitListingObject?.toDate,
      page: !forPagination ? 0 : page,
      size: rowsPerPage,
      processType: "cleaning",
    };
    fetchTransferCssdItemsKitListCSSDRe(listObj).then((response) => {
      if (forPagination) {
        setCleaningKitList((prevData) => [
          ...prevData,
          ...response?.data?.result?.map((val) => ({
            Select: false,
            ...val,
          })),
        ]);
      } else {
        setCleaningKitList(
          response?.data?.result?.length > 0
            ? response.data.result?.map((val) => ({
              Select: false,
              ...val,
            }))
            : []
        );
        setKitPage(0);
      }
      if (response?.data?.count) {
        setKitCount(response?.data?.count);
      }
    });
  };

  const handleSurgeonNameChange = (inputValue) => {
    if (typeof inputValue !== "string") return;

    setSearchBarString(inputValue);

    const trimmedValue = inputValue.trim();

    if (
      trimmedValue.length > 0 &&
      UseCheckConsecutiveCharacters(trimmedValue)
    ) {
      autoSearchSurgeonName(trimmedValue)
        .then((res) => {
          setSurgeonOptions(res?.data?.result ?? []);
        })
        .catch(() => {
          setSurgeonOptions([]);
        });
    } else {
      setSurgeonOptions([]);
    }
  };

  const handlehandoverByChange = (inputValue) => {
    if (typeof inputValue !== "string") return;

    setSearchBarString(inputValue);

    const trimmedValue = inputValue.trim();

    if (
      trimmedValue.length > 0 &&
      UseCheckConsecutiveCharacters(trimmedValue)
    ) {
      autoSearchHandoverReceived(trimmedValue)
        .then((res) => {
          setHandoverOptions(res?.data?.result ?? []);
        })
        .catch(() => {
          setHandoverOptions([]);
        });
    } else {
      setHandoverOptions([]);
    }
  };

  const handlereceivedOptionsChange = (inputValue) => {
    if (typeof inputValue !== "string") return;

    setSearchBarString(inputValue);

    const trimmedValue = inputValue.trim();

    if (
      trimmedValue.length > 0 &&
      UseCheckConsecutiveCharacters(trimmedValue)
    ) {
      autoSearchHandoverReceived(trimmedValue)
        .then((res) => {
          setReceivedOptions(res?.data?.result ?? []);
        })
        .catch(() => {
          setReceivedOptions([]);
        });
    } else {
      setReceivedOptions([]);
    }
  };

  const handleFromStoreChange = (inputValue) => {
    if (typeof inputValue !== "string") return;

    setSearchBarString(inputValue);

    const trimmedValue = inputValue.trim();

    if (
      trimmedValue.length > 0 &&
      UseCheckConsecutiveCharacters(trimmedValue)
    ) {
      getStoreDropdown(trimmedValue)
        .then((res) => {
          setStoreOptions(res?.data?.result ?? []);
        })
        .catch(() => {
          setStoreOptions([]);
        });
    } else {
      setStoreOptions([]);
    }
  };

  const handleCancelDelete = () => {
    setFinalTabs(prev =>
      prev.map((kit, kitIndex) =>
        kitIndex !== values
          ? kit
          : {
            ...kit,
            items: kit.items.map(item =>
              item.pendingDelete
                ? { ...item, pendingDelete: false }
                : item
            ),
          }
      )
    );

    setPendingRow(null);
    setOpenModel(false);
  };

  const handleConfirmDelete = async (e) => {
    e?.preventDefault();
    if (!pendingRow) return;

    try {
      const res = await deletecleaningwrappingItem(pendingRow.id);

      if (res?.status === 200) {
        setGroupedItems(prev => {
          const newState = { ...prev };

          Object.keys(newState).forEach(kitId => {
            newState[kitId] = newState[kitId].filter(
              item => Number(item.id) !== Number(pendingRow.id)
            );
          });

          return newState;
        });
      }
    } catch (error) {
      console.error(error);
    } finally {
      setPendingRow(null);
      setOpenModel(false);
    }
  };

  const handleDeleteClick = (row) => {
    setFinalTabs(prev =>
      prev.map((kit, kitIndex) =>
        kitIndex !== values
          ? kit
          : {
            ...kit,
            items: kit.items.map(item =>
              item.id === row.id
                ? { ...item, pendingDelete: true } // ✅ SAME DATA
                : item
            ),
          }
      )
    );

    setPendingRow(row);
    setOpenModel(true);
  };


  const handleAdd = () => {

    if (!selectedKit) return warningAlert("Please select a target kit!");

    if (!getAddKitItemSearch?.id) return warningAlert("Select item!");

    const itemId = getAddKitItemSearch?.id;

    const exists = groupedItems[selectedKit]?.some(
      item => item["Item Code"] === itemId
    );

    if (exists) return warningAlert("Item already exists in this kit!");

    setGroupedItems(prev => ({
      ...prev,
      [selectedKit]: [
        ...prev[selectedKit],
        {
          "Item Code": itemId,
          "Item Name": getAddKitItemSearch?.label,
        }
      ]
    }));

    setValue("addKitItemSearch", null);
    setSelectedKit(null);
    setOpenAddKitModal(false);
  };

  const populateKitItemTable = (id, kitBatchNo, KitName, kitId, kitName, srNo, newBatch) => {
    // if (newBatch === true) {
    //   getItemsinItemKitById(
    //     getUserInfo?.loginStoreId,
    //     getUserInfo?.loginUnitId,
    //     kitId
    //   ).then((response) => {
    //     let kitArray = response?.data?.result?.map((item, itemInd) => ({
    //       Select: true,
    //       "Sr No": itemInd + 1,
    //       Id: null,
    //       "Created Date": format(new Date(), "yyyy-MM-dd'T'HH:mm:ss"),
    //       "Last Modified Date": format(new Date(), "yyyy-MM-dd'T'HH:mm:ss"),
    //       "Created By": null,
    //       "Last Modified By": null,
    //       "Item Id": item?.id,
    //       "Item Code": item?.itemCode,
    //       "Item Name": item?.label,
    //       "Item Kit Code": kitId,
    //       "Item Kit Name": kitName,
    //       "Receive Qty": null,
    //       "Cleaned Qty": item?.itemQuantity,
    //       "Old Cleaned Qty": item?.itemQuantity,
    //       "Ot Details Id": null,
    //       "Receive Date": null,
    //       Status: null,
    //       "Transfer Date": null,
    //       "Received By": null,
    //       "Sent By": null,
    //       "Old Cleaned Qty": item?.itemQuantity,
    //       "Cleaning Status": false,
    //       "Decontamination Status": false,
    //       "Sterilization Qty": null,
    //       "Sterilization Status": false,
    //       "Transfer Qty": null,
    //       "Issue Date": null,
    //       "Issue Qty": null,
    //       "Issue Status": null,
    //       "Issued By": null,
    //       "Disposed Date": null,
    //       "Disposed By": null,
    //       "Wrapped Qty": null,
    //       "Wrapping Status": false,
    //       "Cleaned By": null,
    //       "Wrapped By": null,
    //       "Sterilized By": null,
    //       "Receive Status": false,
    //       "Sterilization Status Type": null,
    //       "Transfer Status": false,
    //       "Sterilization End By": null,
    //       "Sterilization Start By": null,
    //       "Transferred By": null,
    //       "Used Quantity": null,
    //       Temperature: null,
    //       "Sterilization ExpiryDate": null,
    //       "AddToStock Qty": null,
    //       "Cleaning Start Date": null,
    //       "Cleaning End Date": null,
    //       "Wrapping Start Date": null,
    //       "Wrapping End Date": null,
    //       Pressure: null,
    //       "Kit BatchNo": kitBatchNo,
    //       "Item BatchNo": null,
    //       "CSSD LotNo": null,
    //       "Sterilization Equipment Id": null,
    //       "Machine Id": null,
    //       "Machine Name": null,
    //       "Sterilization Start Date": null,
    //       "Sterilization End Date": null,
    //       "Wrapper Type Id": null,
    //       "Wrapper Type": null,
    //       "Wrapping Method Id": null,
    //       "Wrapping Method": null,
    //       "Sterilization Equipment": null,
    //       "Sterilization Method Id": null,
    //       "Sterilization Method": null,
    //       "Cssd Transfer Id": null,
    //       "Disposed Qty": null,
    //       "Disposed Reason": null,
    //       newBatch: true,
    //     }));

    //     const updateBatchLists = async () => {
    //       const newKitArray = await Promise.all(
    //         kitArray.map(async (val) => ({
    //           ...val,
    //           batchNoList: await getItemWiseBatchNoDropdown(
    //             val["Item Id"],
    //             getUserInfo?.loginStoreId,
    //             getUserInfo?.loginUnitId
    //           ).then((res) => res?.data?.result ?? []),
    //         }))
    //       );

    //       const kitObj = {
    //         kitName: kitName,
    //         srNo: srNo,
    //         kitItemList: newKitArray?.length > 0 ? newKitArray : [],
    //       };
    //       setCleaningKitItemsList((prevData) => [...prevData, { ...kitObj }]);
    //     };
    //     setNewKitBatch("");
    //     setExistKitBatch("");
    //     updateBatchLists();
    //   });
    // } else if (newBatch === false) {
    //   getBatchwiseItemsForKit(
    //     getUserInfo?.loginStoreId,
    //     getUserInfo?.loginUnitId,
    //     kitId,
    //     kitBatchNo
    //   ).then((response) => {
    //     console.log("ExistResponse321", response?.data?.result);
    //     let kitArray = response?.data?.result?.map((item, itemInd) => ({
    //       Select: true,
    //       "Sr No": itemInd + 1,
    //       Id: null,
    //       "Created Date": format(new Date(), "yyyy-MM-dd'T'HH:mm:ss"),
    //       "Last Modified Date": format(new Date(), "yyyy-MM-dd'T'HH:mm:ss"),
    //       "Created By": null,
    //       "Last Modified By": null,
    //       "Item Id": item?.itemid,
    //       "Item Code": item?.itemcode,
    //       "Item Name": item?.label,
    //       "Item Kit Code": kitId,
    //       "Item Kit Name": kitName,
    //       "Receive Qty": null,
    //       "Cleaned Qty": item?.itemquantity,
    //       "Old Cleaned Qty": item?.itemquantity,
    //       "Ot Details Id": null,
    //       "Receive Date": null,
    //       Status: null,
    //       "Transfer Date": null,
    //       "Received By": null,
    //       "Sent By": null,
    //       "Old Cleaned Qty": item?.itemquantity,
    //       "Cleaning Status": false,
    //       "Decontamination Status": false,
    //       "Sterilization Qty": null,
    //       "Sterilization Status": false,
    //       "Transfer Qty": null,
    //       "Issue Date": null,
    //       "Issue Qty": null,
    //       "Issue Status": null,
    //       "Issued By": null,
    //       "Disposed Date": null,
    //       "Disposed By": null,
    //       "Wrapped Qty": null,
    //       "Wrapping Status": false,
    //       "Cleaned By": null,
    //       "Wrapped By": null,
    //       "Sterilized By": null,
    //       "Receive Status": false,
    //       "Sterilization Status Type": null,
    //       "Transfer Status": false,
    //       "Sterilization End By": null,
    //       "Sterilization Start By": null,
    //       "Transferred By": null,
    //       "Used Quantity": null,
    //       Temperature: null,
    //       "Sterilization ExpiryDate": null,
    //       "AddToStock Qty": null,
    //       "Cleaning Start Date": null,
    //       "Cleaning End Date": null,
    //       "Wrapping Start Date": null,
    //       "Wrapping End Date": null,
    //       Pressure: null,
    //       "Kit BatchNo": kitBatchNo,
    //       "Item BatchNo": item?.itembatchno,
    //       "CSSD LotNo": null,
    //       "Sterilization Equipment Id": null,
    //       "Machine Id": null,
    //       "Machine Name": null,
    //       "Sterilization Start Date": null,
    //       "Sterilization End Date": null,
    //       "Wrapper Type Id": null,
    //       "Wrapper Type": null,
    //       "Wrapping Method Id": null,
    //       "Wrapping Method": null,
    //       "Sterilization Equipment": null,
    //       "Sterilization Method Id": null,
    //       "Sterilization Method": null,
    //       "Cssd Transfer Id": null,
    //       "Disposed Qty": null,
    //       "Disposed Reason": null,
    //       newBatch: false,
    //     }));

    //     const updateBatchLists = async () => {
    //       const newKitArray = await Promise.all(
    //         kitArray.map(async (val) => ({
    //           ...val,
    //           batchNoList: await getItemWiseBatchNoDropdown(
    //             val["Item Id"],
    //             getUserInfo?.loginStoreId,
    //             getUserInfo?.loginUnitId
    //           ).then((res) => res?.data?.result ?? []),
    //         }))
    //       );

    //       const kitObj = {
    //         kitName: kitName,
    //         srNo: srNo,
    //         kitItemList: newKitArray?.length > 0 ? newKitArray : [],
    //       };
    //       setCleaningKitItemsList((prevData) => [...prevData, { ...kitObj }]);
    //     };
    //     setNewKitBatch("");
    //     setExistKitBatch("");
    //     updateBatchLists();
    //   });
    // } else {
    let listObj = {
      searchString: "",
      searchId: null,
      fromDate: null,
      toDate: null,
      processType: "cleaning",
      kitId: kitId,
      page: null,
      size: null,
    };
    // fetchTransferCssdItemsList(id, kitBatchNo, KitName).then((response) => {
    //   console.log("kitResponse", response);
    //   let newItems =
    //     response?.data?.statusCode === 200
    //       ? response?.data?.result?.map((val) => ({
    //         Select: true,
    //         "id": val?.["id"],
    //         "Item Code": val?.["item_id"],
    //         "Item Name": val?.["ItemName"],
    //         "kidId": val?.["item_kit_id"],
    //         "Kit Name": val?.["KitName"],
    //         "Cleaned Qty": val?.["Receive Qty"],
    //         "Old Cleaned Qty": val?.["Receive Qty"],
    //         "Disposed Qty": val?.["Disposed Qty"],
    //         "Disposed Reason": val?.["Disposed Reason"],
    //       }))
    //       : [];
    //   let kitObj = {
    //     id,
    //     kitBatchNo,
    //     KitName,
    //     kitItemList: newItems?.length > 0 ? newItems : [],
    //   };
    //   setCleaningKitItemsList((prevData) => [...prevData, { ...kitObj }]);
    // });

    const groupedKits = Object.values(
      cleaningKitItemsList.reduce((acc, item) => {
        const kitId = item.kitId || 0;

        if (!acc[kitId]) {
          acc[kitId] = {
            kitId,
            KitName: item.KitName || `Kit ${kitId}`,
            kitItemList: []
          };
        }

        acc[kitId].kitItemList.push(item);
        return acc;
      }, {})
    );



    fetchTransferCssdItemsList(id, kitBatchNo, KitName).then((response) => {
      console.log("kitResponse", response);

      let newItems =
        response?.data?.statusCode === 200
          ? response?.data?.result?.map((val) => ({
            Select: true,
            Delete: "",
            // pass: val?.pass ?? 1,
            id: val?.id,
            "Item Code": val?.item_id,
            "Item Name": val?.ItemName,
            // kitId: val?.item_kit_id,    // FIX: "kidId" → "kitId"
            kitId: val?.kitId ?? val?.item_kit_id ?? 0,
            "KitName": val?.KitName,
            "kitBatchNo": val?.kitBatchNo,
            "Cleaned Qty": val?.["quantity"],
            "Old Cleaned Qty": val?.["Receive Qty"],
            "Disposed Qty": val?.["Disposed Qty"],
            "Disposed Reason": val?.["Disposed Reason"],
          }))
          : [];

      const kitObj = {
        id,
        kitBatchNo,
        KitName,
        kitItemList: newItems?.length > 0 ? newItems : [],
      };

      setCleaningKitItemsList((prevData) => [...prevData, kitObj]);
    });

  };

  console.log("cleaningKitItemsList", cleaningKitItemsList);

  // const renderInputItem = (row, index, header) => {
  //   setValue(`disposedReason${row?.["Sr No"]}`, row?.["Disposed Reason"]);

  //   return (
  //     <div className="-my-2">
  //       {header === "Select" && (
  //         <Checkbox
  //           size="small"
  //           name={`Select${row?.["Sr No"]}`}
  //           checked={row?.Select}
  //           onChange={(e) => {
  //             setCleaningItemsList((prevTransferItemList) =>
  //               prevTransferItemList.map((val, i) =>
  //                 val?.["Item Code"] === row?.["Item Code"] &&
  //                   val?.["Sr No"] === row?.["Sr No"]
  //                   ? { ...val, Select: e.target.checked }
  //                   : val
  //               )
  //             );
  //           }}
  //         />
  //       )}
  //       {header === "Cleaned Qty" && (
  //         <input
  //           type="number"
  //           name={`cleanedQty${row?.["Sr No"]}`}
  //           value={row?.["Cleaned Qty"]}
  //           className="border border-black rounded w-28 px-2"
  //           onChange={(e) => {
  //             setCleaningItemsList((prevTransferItemList) =>
  //               prevTransferItemList.map((val, i) =>
  //                 val?.["Item Code"] === row?.["Item Code"] &&
  //                   val?.["Sr No"] === row?.["Sr No"]
  //                   ? { ...val, ["Cleaned Qty"]: e.target.value }
  //                   : val
  //               )
  //             );
  //           }}
  //           onWheel={(e) => e.target.blur()}
  //           onKeyDown={(e) =>
  //             ["ArrowUp", "ArrowDown", "e", "E", "+", "-", "*", "/"].includes(
  //               e.key
  //             ) && e.preventDefault()
  //           }
  //         />
  //       )}
  //       {/* {header === "Disposed Qty" && (
  //         <input
  //           type="number"
  //           value={Number(row?.["Disposed Qty"])}
  //           name={`disposedQty${row?.["Sr No"]}`}
  //           className="border border-black rounded w-28 px-2"
  //           onChange={(e) => {
  //             if (e.target.value <= Number(row?.["Old Cleaned Qty"])) {
  //               setTransferReceiveItemsList((prevTransferItemList) =>
  //                 prevTransferItemList.map((val, i) =>
  //                   val?.["Item Code"] === row?.["Item Code"] &&
  //                     val?.["Sr No"] === row?.["Sr No"]
  //                     ? {
  //                       ...val,
  //                       "Disposed Qty": e.target.value,
  //                       "Cleaned Qty":
  //                         e.target.value !== ""
  //                           ? val?.["Old Cleaned Qty"] - e.target.value
  //                           : val?.["Old Cleaned Qty"],
  //                     }
  //                     : val
  //                 )
  //               );
  //             }
  //           }}
  //           onWheel={(e) => e.target.blur()}
  //           onKeyDown={(e) =>
  //             ["ArrowUp", "ArrowDown", "e", "E", "+", "-", "*", "/"].includes(
  //               e.key
  //             ) && e.preventDefault()
  //           }
  //         />
  //       )} */}
  //       {header === "Disposed Qty" && (
  //         <input
  //           type="number"
  //           name={`disposedQty${row?.["Sr No"]}`}
  //           value={row?.["Disposed Qty"]}
  //           className="border border-black rounded w-28 px-2"
  //           onChange={(e) => {
  //             setCleaningItemsList((prevTransferItemList) =>
  //               prevTransferItemList.map((val, i) =>
  //                 val?.["Item Code"] === row?.["Item Code"] &&
  //                   val?.["Sr No"] === row?.["Sr No"]
  //                   ? { ...val, ["Disposed Qty"]: e.target.value }
  //                   : val
  //               )
  //             );
  //           }}
  //           onWheel={(e) => e.target.blur()}
  //           onKeyDown={(e) =>
  //             ["ArrowUp", "ArrowDown", "e", "E", "+", "-", "*", "/"].includes(
  //               e.key
  //             ) && e.preventDefault()
  //           }
  //         />
  //       )}
  //       {header === "Disposed Reason" && (
  //         <input
  //           type="text"
  //           name={`disposedReason${row?.["Sr No"]}`}
  //           value={row?.["Disposed Reason"]}
  //           className="border border-black rounded w-28 px-2"
  //           disabled={
  //             row?.["Disposed Qty"] <= 0 || row?.["Disposed Qty"] === null
  //           }
  //           onChange={(e) => {
  //             setTransferReceiveItemsList((prevTransferItemList) =>
  //               prevTransferItemList.map((val, i) =>
  //                 val?.["Item Code"] === row?.["Item Code"] &&
  //                   val?.["Sr No"] === row?.["Sr No"]
  //                   ? { ...val, "Disposed Reason": e.target.value }
  //                   : val
  //               )
  //             );
  //           }}
  //         />
  //       )}
  //     </div>
  //   );
  // };

  // const renderInputKit = (row, index, header) => {
  //   return (
  //     <div className="-my-2">
  //       {header === "Select" && (
  //         <Checkbox
  //           size="small"
  //           name={`SelectKit${row?.["Sr No"]}`}
  //           checked={row?.Select}
  //           onChange={(e) => {
  //             setCleaningKitList((prevData) =>
  //               prevData?.map((kit) => ({
  //                 ...kit,
  //                 Select:
  //                   kit?.["Item Kit Code"] === row?.["Item Kit Code"] &&
  //                     kit?.["Sr No"] === row?.["Sr No"]
  //                     ? e.target.checked
  //                     : kit?.Select,
  //               }))
  //             );
  //             if (e.target.checked) {
  //               if (cleaningKitItemsList?.length === 0) {
  //                 setValues(0);
  //               }

  //               populateKitItemTable(
  //                 row?.id,
  //                 row?.kitBatchNo,
  //                 row?.KitName
  //               );
  //             } else {
  //               setCleaningKitItemsList(
  //                 cleaningKitItemsList?.filter(
  //                   (val) => val?.srNo !== row?.["Sr No"]
  //                 )
  //               );
  //             }
  //           }}
  //         />
  //       )}
  //     </div>
  //   );
  // };

  // Local state for selected rows

  const renderInputItem = (row, index, header) => {
    setValue(`disposedReason${row?.["Sr No"]}`, row?.["Disposed Reason"]);

    return (
      <div className="-my-2">

        {/* SELECT CHECKBOX */}
        {header === "Select" && (
          <Checkbox
            size="small"
            name={`Select${row?.["Sr No"]}`}
            checked={row?.Select}
            onChange={(e) => {
              setCleaningItemsList((prev) =>
                prev.map((val) =>
                  val["Item Code"] === row["Item Code"] &&
                    val["Sr No"] === row["Sr No"]
                    ? { ...val, Select: e.target.checked }
                    : val
                )
              );
            }}
          />
        )}

        {/* CLEANED QTY */}
        {header === "Cleaned Qty" && (
          <input
            type="number"
            name={`cleanedQty${row?.["Sr No"]}`}
            value={row?.["Cleaned Qty"]}
            className="border border-black rounded w-28 px-2"
            onChange={(e) => {
              const value = e.target.value;

              setCleaningItemsList((prev) =>
                prev.map((val) =>
                  val["Item Code"] === row["Item Code"] &&
                    val["Sr No"] === row["Sr No"]
                    ? { ...val, "Cleaned Qty": value }
                    : val
                )
              );
            }}
            onWheel={(e) => e.target.blur()}
            onKeyDown={(e) =>
              ["ArrowUp", "ArrowDown", "e", "E", "+", "-", "*", "/"].includes(
                e.key
              ) && e.preventDefault()
            }
          />
        )}

        {/* DISPOSED QTY */}
        {header === "Disposed Qty" && (
          <input
            type="number"
            name={`disposedQty${row?.["Sr No"]}`}
            value={row?.["Disposed Qty"]}
            className="border border-black rounded w-28 px-2"
            onChange={(e) => {
              const value = e.target.value;

              setCleaningItemsList((prev) =>
                prev.map((val) =>
                  val["Item Code"] === row["Item Code"] &&
                    val["Sr No"] === row["Sr No"]
                    ? { ...val, "Disposed Qty": value }
                    : val
                )
              );
            }}
            onWheel={(e) => e.target.blur()}
            onKeyDown={(e) =>
              ["ArrowUp", "ArrowDown", "e", "E", "+", "-", "*", "/"].includes(
                e.key
              ) && e.preventDefault()
            }
          />
        )}

        {/* DISPOSED REASON */}
        {header === "Disposed Reason" && (
          <input
            type="text"
            name={`disposedReason${row?.["Sr No"]}`}
            value={row?.["Disposed Reason"]}
            className="border border-black rounded w-28 px-2"
            disabled={row?.["Disposed Qty"] <= 0 || row?.["Disposed Qty"] === null}
            onChange={(e) => {
              const value = e.target.value;

              setCleaningItemsList((prev) =>
                prev.map((val) =>
                  val["Item Code"] === row["Item Code"] &&
                    val["Sr No"] === row["Sr No"]
                    ? { ...val, "Disposed Reason": value }
                    : val
                )
              );
            }}
          />
        )}
      </div>
    );
  };


  const [selectedKitRows, setSelectedKitRows] = useState({});

  // const renderInputKit = (row, index, header) => {
  //   return (
  //     <div className="-my-2">
  //       {header === "Select" && (
  //         <Checkbox
  //           size="small"
  //           name={`SelectKit${row?.id}`}
  //           checked={!!selectedKitRows[row.id] || false}   // independent selection
  //           onChange={(e) => {
  //             const isChecked = e.target.checked;

  //             // 1️⃣ Update local selected state
  //             setSelectedKitRows((prev) => ({
  //               ...prev,
  //               [row.id]: isChecked,
  //             }));

  //             // 2️⃣ Update main list only for this row
  //             setCleaningKitList((prev) =>
  //               prev.map((kit) =>
  //                 kit.id === row.id
  //                   ? { ...kit, Select: isChecked }
  //                   : kit
  //               )
  //             );

  //             // 3️⃣ Handle add/remove
  //             if (isChecked) {
  //               if (cleaningKitItemsList?.length === 0) {
  //                 setValues(0);
  //               }

  //               populateKitItemTable(row.id, row.kitBatchNo, row.KitName);
  //             } else {
  //               setCleaningKitItemsList((prev) =>
  //                 prev.filter((item) => item.id !== row.id)
  //               );
  //             }
  //           }}
  //         />
  //       )}
  //     </div>
  //   );
  // };

  const renderInputKit = (row, index, header) => {
    return (
      <div className="-my-2">

        {/* SELECT CHECKBOX */}
        {header === "Select" && (
          <Checkbox
            size="small"
            name={`SelectKit${row?.id}`}
            checked={!!selectedKitRows[row.id]}
            onChange={(e) => {
              const isChecked = e.target.checked;

              // 1️⃣ Update selection state
              setSelectedKitRows((prev) => ({
                ...prev,
                [row.id]: isChecked,
              }));

              // 2️⃣ Update main kit list
              setCleaningKitList((prev) =>
                prev.map((kit) =>
                  kit.id === row.id ? { ...kit, Select: isChecked } : kit
                )
              );

              // 3️⃣ Add OR Remove from kit item list
              if (isChecked) {
                // Set first tab index
                if (cleaningKitItemsList.length === 0) {
                  setValues(0);
                }

                // Load kit items
                populateKitItemTable(row.id, row.kitBatchNo, row.KitName);
              } else {
                // Remove kit items of this kit
                setCleaningKitItemsList((prev) =>
                  prev.filter((kit) => kit.id !== row.id)
                );
              }
            }}
          />
        )}
      </div>
    );
  };

  const renderInputKitItem = (row, index, header) => {
    setValue(`${values}disposedReason${index}`, row?.["Disposed Reason"]);
    setValue(
      `${values}kitItemBatchNo${index}`,
      row?.["Item BatchNo"]
        ? {
          value: row?.["Item BatchNo"],
          label: row?.["Item BatchNo"],
        }
        : null
    );
    return (
      <div className="-my-2">
        {header === "Select" && (
          <Checkbox
            size="small"
            name={`${values}SelectKitItem${index}`}
            checked={row?.Select}
            onChange={(e) => {

            }}
          />
        )}

        {header === "Delete" && (
          <IconButton
            size="small"
            color="error"
            onClick={() => handleDeleteClick(row)}
          >
            <DeleteIcon fontSize="small" />
          </IconButton>
        )}


        {/* {header === "Cleaned Qty" && (
          <input
            type="number"
            name={`${values}cleanedQty${index}`}
            value={row?.["Cleaned Qty"] || ""}
            className="border border-black rounded w-28 px-2"
            onChange={(e) => {
              const value = e.target.value;

              setCleaningKitItemsList((prev) =>
                prev.map((kit) => ({
                  ...kit,
                  kitItemList: kit.kitItemList.map((val) =>
                    String(val["Item Code"]) === String(row["Item Code"]) &&
                      val["Sr No"] === row["Sr No"]
                      ? { ...val, "Cleaned Qty": value }
                      : val
                  ),
                }))
              );
            }}
            onWheel={(e) => e.target.blur()}
            onKeyDown={(e) =>
              ["ArrowUp", "ArrowDown", "e", "E", "+", "-", "*", "/"].includes(e.key) &&
              e.preventDefault()
            }
          />
        )} */}


        {/* {header === "Cleaned Qty" && (
          <input
            type="text"
            inputMode="numeric"
            pattern="[0-9]*"
            className="border border-black rounded w-28 px-2 text-left"
            defaultValue={row?.["Cleaned Qty"] || ""}
            onChange={(e) => {
              const numeric = e.target.value.replace(/\D/g, "");

              setCleaningKitItemsList(prev =>
                prev.map(kit =>
                  Number(kit.id) !== Number(row.kitId)
                    ? kit
                    : {
                      ...kit,
                      kitItemList: kit.kitItemList.map(item =>
                        String(item["Item Code"]) === String(row["Item Code"])
                          ? { ...item, "Cleaned Qty": numeric }
                          : item
                      ),
                    }
                )
              );
            }}
          />
        )} */}

        {/* {header === "Disposed Qty" && (
          <input
            type="number"
            value={Number(row?.["Disposed Qty"])}
            name={`${values}disposedQty${index}`}
            className="border border-black rounded w-28 px-2"
            onChange={(e) => {
              if (e.target.value <= Number(row?.["Old Cleaned Qty"])) {
                setCleaningKitItemsList((prevDataObj) =>
                  prevDataObj?.map((kit, kitInd) => ({
                    ...kit,
                    kitItemList: kit.kitItemList?.map((val) =>
                      values === kitInd &&
                        val?.["Item Code"] === row?.["Item Code"] &&
                        val?.["Sr No"] === row?.["Sr No"]
                        ? {
                          ...val,
                          "Disposed Qty": e.target.value,
                          "Cleaned Qty":
                            e.target.value !== ""
                              ? val?.["Old Cleaned Qty"] - e.target.value
                              : val?.["Old Cleaned Qty"],
                        }
                        : val
                    ),
                  }))
                );
              }
            }}
            onWheel={(e) => e.target.blur()}
            onKeyDown={(e) =>
              ["ArrowUp", "ArrowDown", "e", "E", "+", "-", "*", "/"].includes(
                e.key
              ) && e.preventDefault()
            }
          />
        )} */}
        {/* {header === "Disposed Qty" && (
          <input
            type="number"
            name={`disposedQty${row?.["Sr No"]}`}
            value={row?.["Disposed Qty"]}
            className="border border-black rounded w-28 px-2"
            onChange={(e) => {
              setCleaningItemsList((prevTransferItemList) =>
                prevTransferItemList.map((val, i) =>
                  val?.["Item Code"] === row?.["Item Code"] &&
                    val?.["Sr No"] === row?.["Sr No"]
                    ? { ...val, ["Disposed Qty"]: e.target.value }
                    : val
                )
              );
            }}
            onWheel={(e) => e.target.blur()}
            onKeyDown={(e) =>
              ["ArrowUp", "ArrowDown", "e", "E", "+", "-", "*", "/"].includes(
                e.key
              ) && e.preventDefault()
            }
          />
        )} */}

        {header === "Disposed Reason" && (
          <input
            type="text"
            name={`${values}disposedReason${index}`}
            value={row?.["Disposed Reason"]}
            className="border border-black rounded w-28 px-2"
            disabled={
              row?.["Disposed Qty"] <= 0 || row?.["Disposed Qty"] === null
            }
            onChange={(e) => {
              setCleaningKitItemsList((prevDataObj) =>
                prevDataObj?.map((kit, kitInd) => ({
                  ...kit,
                  kitItemList: kit.kitItemList?.map((val) =>
                    values === kitInd &&
                      val?.["Item Code"] === row?.["Item Code"] &&
                      val?.["Sr No"] === row?.["Sr No"]
                      ? { ...val, "Disposed Reason": e.target.value }
                      : val
                  ),
                }))
              );
            }}
          />
        )}
        {header === "Item BatchNo" && (
          <>
            {row?.newBatch === true || row?.newBatch === false ? (
              <TableDropDownField
                control={control}
                name={`${values}kitItemBatchNo${index}`}
                dataArray={row?.batchNoList}
                isClearable={true}
                inputRef={{
                  ...register(`${values}kitItemBatchNo${index}`, {
                    onChange: (e) => {
                      setCleaningKitItemsList((prevDataObj) =>
                        prevDataObj?.map((kit, kitInd) => ({
                          ...kit,
                          kitItemList: kit.kitItemList?.map((val) =>
                            values === kitInd &&
                              val?.["Item Code"] === row?.["Item Code"] &&
                              val?.["Sr No"] === row?.["Sr No"]
                              ? {
                                ...val,
                                "Item BatchNo": e.target.value?.label,
                              }
                              : val
                          ),
                        }))
                      );
                    },
                  }),
                }}
              />
            ) : (
              <div>{row?.["Item BatchNo"]}</div>
            )}
          </>
        )}
      </div>
    );
  };

  // const addToStockList = () => {
  //   let itemDetailsArray =
  //     getItemType === "Item"
  //       ? cleaningItemsList
  //       : cleaningKitItemsList
  //         ?.flatMap((val) => val?.kitItemList)
  //         ?.filter((fil) => fil.Select === true);
  //   let postObject = {
  //     id: null,
  //     fromStore: getUserInfo?.loginStoreId,
  //     toStore: getUserInfo?.loginStoreId,
  //     itemDetailsRequestDtoList: itemDetailsArray
  //       ?.filter((val) => val?.Select === true)
  //       ?.map((item) => ({
  //         id: item?.Id,
  //         cssdTransferId: item?.["Cssd Transfer Id"]
  //           ? item?.["Cssd Transfer Id"]
  //           : null,
  //         otDetails:
  //           item?.["Ot Details Id"] !== null
  //             ? {
  //               id: item?.["Ot Details Id"],
  //             }
  //             : null,
  //         item:
  //           item?.["Item Id"] !== null
  //             ? {
  //               id: item?.["Item Id"],
  //             }
  //             : null,
  //         itemKit:
  //           item?.["Item Kit Code"] !== null
  //             ? {
  //               id: item?.["Item Kit Code"],
  //             }
  //             : null,
  //         transferDate:
  //           item?.["Transfer Date"] !== null
  //             ? item?.["Transfer Date"]?.replace(" ", "T")?.split(".")[0]
  //             : null,
  //         transferQty: item?.["Transfer Qty"]
  //           ? Number(item?.["Transfer Qty"])
  //           : null,
  //         transferStatus: item?.["Transfer Status"],
  //         transferredBy:
  //           item?.["Transferred By"] !== null
  //             ? { id: item?.["Transferred By"] }
  //             : null,

  //         issueDate:
  //           item?.["Issue Date"] !== null
  //             ? item?.["Issue Date"]?.replace(" ", "T")
  //             : null,
  //         issueStatus: item?.["Issue Status"],
  //         issueQty:
  //           item?.["Issue Qty"] !== null ? Number(item?.["Issue Qty"]) : null,
  //         issuedBy:
  //           item?.["Issued By"] !== null ? { id: item?.["Issued By"] } : null,

  //         disposedDate:
  //           item?.["Disposed Date"] !== null
  //             ? item?.["Disposed Date"]?.replace(" ", "T")
  //             : null,
  //         disposedQty: item?.["Disposed Qty"]
  //           ? Number(item?.["Disposed Qty"])
  //           : null,
  //         disposedBy:
  //           item?.["Disposed By"] !== null
  //             ? { id: item?.["Disposed By"] }
  //             : null,

  //         receiveDate:
  //           item?.["Receive Date"] !== null
  //             ? item?.["Receive Date"]?.replace(" ", "T")
  //             : null,
  //         receiveQty: item?.["Receive Qty"]
  //           ? Number(item?.["Receive Qty"])
  //           : null,
  //         receiveStatus: true,
  //         receivedBy: item?.["Received By"]
  //           ? { id: item?.["Received By"] }
  //           : null,

  //         cleaningStatus: true,
  //         cleanedQty:
  //           item?.["Cleaned Qty"] !== null
  //             ? Number(item?.["Cleaned Qty"])
  //             : null,
  //         cleaningStartDate: format(new Date(), "yyyy-MM-dd'T'HH:mm:ss"),
  //         cleaningEndDate: format(new Date(), "yyyy-MM-dd'T'HH:mm:ss"),
  //         cleanedBy: { id: getUserInfo?.employeeId },

  //         wrappedQty:
  //           item?.["Wrapped Qty"] !== null
  //             ? Number(item?.["Wrapped Qty"])
  //             : null,
  //         wrappingStatus: item?.["Wrapping Status"],
  //         wrappedBy:
  //           item?.["Wrapped By"] !== null ? { id: item?.["Wrapped By"] } : null,
  //         wrapperType:
  //           item?.["Wrapper Type Id"] !== null
  //             ? { id: item?.["Wrapper Type Id"] }
  //             : null,
  //         wrappingMethod:
  //           item?.["Wrapping Method Id"] !== null
  //             ? { id: item?.["Wrapping Method Id"] }
  //             : null,
  //         wrappingStartDate: format(new Date(), "yyyy-MM-dd'T'HH:mm:ss"),
  //         wrappingEndDate:
  //           item?.["Wrapping End Date"] !== null
  //             ? item?.["Wrapping End Date"]?.replace(" ", "T")
  //             : null,

  //         sterilizationQty:
  //           item?.["Sterilization Qty"] !== null
  //             ? Number(item?.["Sterilization Qty"])
  //             : null,
  //         sterilizationStatus: item?.["Sterilization Status"],
  //         sterilizationStatusType: item?.["Sterilization Status Type"],
  //         sterilizationStartBy:
  //           item?.["Sterilization Start By"] !== null
  //             ? { id: item?.["Sterilization Start By"] }
  //             : null,
  //         sterilizationEndBy:
  //           item?.["Sterilization End By"] !== null
  //             ? { id: item?.["Sterilization End By"] }
  //             : null,
  //         sterilizationStartDate:
  //           item?.["Sterilization Start Date"] !== null
  //             ? item?.["Sterilization Start Date"]?.replace(" ", "T")
  //             : null,
  //         sterilizationEndDate:
  //           item?.["Sterilization End Date"] !== null
  //             ? item?.["Sterilization End Date"]?.replace(" ", "T")
  //             : null,
  //         sterilizationType:
  //           item?.["Sterilization Equipment Id"] !== null
  //             ? { id: item?.["Sterilization Equipment Id"] }
  //             : null,
  //         sterilizationMethod:
  //           item?.["Sterilization Method Id"] !== null
  //             ? { id: item?.["Sterilization Method Id"] }
  //             : null,
  //         sterilizationExpiryDate:
  //           item?.["Sterilization ExpiryDate"] !== null
  //             ? item?.["Sterilization ExpiryDate"]?.replace(" ", "T")
  //             : null,

  //         addToStockQty:
  //           item?.["AddToStock Qty"] !== null
  //             ? Number(item?.["AddToStock Qty"])
  //             : null,

  //         decontaminationStatus: item?.["Decontamination Status"],
  //         kitBatchNo: item?.["Kit BatchNo"],
  //         itemBatchNo: item?.["Item BatchNo"],
  //         wrappertypeQty: null,
  //         indicatorResults: null,
  //         processType: "cleaning",
  //       })),
  //   };
  //   console.log("postObject", postObject);

  //   setOpenPostModal(false);
  //   setOpenBackdrop(true);
  //   saveTransferCssdItemsParentList(postObject)
  //     .then((response) => {
  //       successAlert(response.data.message);
  //       setOpenPostModal(false);
  //       populateItemTable();
  //       setOpenBackdrop(false);
  //       setView("Wrapping & Packaging");
  //     })
  //     .catch((error) => {
  //       errorAlert(error.message);
  //       setOpenBackdrop(false);
  //     });
  // };


  // const addToStockList = async (selectedProcess) => {
  //   setOpenBackdrop(true); // Show loading

  //   try {
  //     // Get selected items
  //     const itemDetailsArray =
  //       getItemType === "Item"
  //         ? cleaningItemsList?.filter((item) => item.Select)
  //         : cleaningKitItemsList
  //           ?.flatMap((kit) => kit.kitItemList)
  //           ?.filter((item) => item.Select);

  //     if (!itemDetailsArray?.length) {
  //       warningAlert("No items selected to send!");
  //       setOpenBackdrop(false);
  //       return;
  //     }

  //     for (const item of itemDetailsArray) {
  //       const cleanedQty = Number(item["Cleaned Qty"]);
  //       const disposedQty = Number(item["Disposed Qty"]);
  //       const disposedReason = (item["Disposed Reason"] ?? "").trim();

  //       if (
  //         isNaN(cleanedQty) ||
  //         cleanedQty < 0 ||
  //         isNaN(disposedQty) ||
  //         disposedQty < 0 ||
  //         (disposedQty > 0 && disposedReason === "")
  //       ) {
  //         warningAlert("Please ensure Cleaned Qty, Disposed Qty, and Disposed Reason are correctly filled for all selected items.");
  //         setOpenBackdrop(false);
  //         return;
  //       }
  //     }

  //     // Determine process type
  //     const processTypeMap = {
  //       cleaning: "cleaning",
  //       wrapping: "wrapping",
  //       sterilization: "sterilization",
  //     };
  //     const processType = processTypeMap[selectedProcess] || "cleaning";

  //     // Build payload
  //     const payload = itemDetailsArray.map((item) => ({
  //       id: item["id"] || 0,
  //       processType: processType,
  //       ot_details_id: 0,
  //       item_id: item["Item Code"] || 0,
  //       item_kit_id: 0,
  //       quantity: 0,
  //       transferDate: new Date().toISOString(),
  //       transferQty: 0,
  //       transferStatus: true,
  //       transferred_by: 0,
  //       issueDate: new Date().toISOString(),
  //       issueStatus: true,
  //       issueQty: 0,
  //       issued_by: 0,
  //       disposedDate: new Date().toISOString(),
  //       disposedQty: Number(item["Disposed Qty"]),
  //       disposed_by: 0,
  //       disposedReason: item["Disposed Reason"] || null,
  //       receiveDate: new Date().toISOString(),
  //       receiveQty: 0,
  //       receiveStatus: true,
  //       received_by: 0,
  //       cleaningStatus: true,
  //       decontaminationStatus: true,
  //       cleanedQty: Number(item["Cleaned Qty"]),
  //       cleaned_by: 0,
  //       cleaningStartDate: new Date().toISOString(),
  //       cleaningEndDate: new Date().toISOString(),
  //       wrappedQty: 0,
  //       wrappingStatus: true,
  //       wrapped_by: 0,
  //       wrapper_type_id: 0,
  //       wrapperTypeQty: 0,
  //       wrapping_method_id: 0,
  //       wrappingStartDate: new Date().toISOString(),
  //       wrappingEndDate: new Date().toISOString(),
  //       sterilizationQty: 0,
  //       sterilizationStatus: true,
  //       sterilizationStatusType: processType,
  //       sterilization_start_by: 0,
  //       sterilizationStartDate: new Date().toISOString(),
  //       sterilizationEndDate: new Date().toISOString(),
  //       sterilization_end_by: 0,
  //       machine_id: 0,
  //       sterilization_type_id: 0,
  //       sterilization_method: 0,
  //       sterilizationExpiryDate: new Date().toISOString(),
  //       addToStockQty: 0,
  //       temperature: 0,
  //       pressure: 0,
  //       durationMinutes: 0,
  //       indicatorResult: "string",
  //       from_store_id: 0,
  //       to_store_id: 0,
  //       itemBatchNo: item["Item BatchNo"] || "string",
  //       kitBatchNo: item["Kit BatchNo"] || "string",
  //       cssdLotNo: "string",
  //       createdBy: "string",
  //       lastModifiedBy: "string",
  //       createdDate: new Date().toISOString(),
  //       lastModifiedDate: new Date().toISOString(),
  //     }));

  //     // Send payload
  //     const response = await saveTransferCssdItemsParentList(payload);

  //     if (response?.status === 200) {
  //       successAlert(`Items successfully sent for ${processType}!`);
  //       setOpenPostModal(false);

  //       // Refresh tables
  //       if (getItemType === "Item") populateItemTable();
  //       else populateKitTable();

  //       setView("Wrapping & Packaging");
  //     } else {
  //       errorAlert("Failed to send items!");
  //     }
  //   } catch (error) {
  //     console.error("Error sending items:", error);
  //     errorAlert("Something went wrong while sending items.");
  //   } finally {
  //     setOpenBackdrop(false);
  //   }
  // };


  // const addToStockList = async (selectedProcess) => {
  //   setOpenBackdrop(true); // Show loading spinner

  //   try {
  //     // 🧩 Step 1: Get selected items
  //     const itemDetailsArray =
  //       getItemType === "Item"
  //         ? cleaningItemsList?.filter((item) => item.Select)
  //         : cleaningKitItemsList
  //           ?.flatMap((kit) => kit.kitItemList)
  //           ?.filter((item) => item.Select);

  //     // 🧩 Step 2: Validate selection
  //     if (!itemDetailsArray?.length) {
  //       warningAlert("No items selected to send!");
  //       setOpenBackdrop(false);
  //       return;
  //     }
  //     for (const item of itemDetailsArray) {
  //       const cleanedQty = Number(item["Cleaned Qty"]);
  //       const disposedQty = Number(item["Disposed Qty"]);
  //       const disposedReason = (item["Disposed Reason"] ?? "").trim();

  //       if (isNaN(cleanedQty) || cleanedQty < 0) {
  //         warningAlert(`Cleaned Qty must be a non-negative number for item ${item["Item Code"]}.`);
  //         setOpenBackdrop(false);
  //         return;
  //       }

  //       if (isNaN(disposedQty) || disposedQty < 0) {
  //         warningAlert(`Disposed Qty must be a non-negative number for item ${item["Item Code"]}.`);
  //         setOpenBackdrop(false);
  //         return;
  //       }

  //       if (disposedQty > 0 && disposedReason === "") {
  //         warningAlert(`Disposed Reason is required when Disposed Qty > 0 for item ${item["Item Code"]}.`);
  //         setOpenBackdrop(false);
  //         return;
  //       }
  //     }

  //     // 🧩 Step 4: Determine process type
  //     const processTypeMap = {
  //       cleaning: "cleaning",
  //       wrapping: "wrapping",
  //       sterilization: "sterilization",
  //     };
  //     const processType = processTypeMap[selectedProcess] || "cleaning";

  //     // 🧩 Step 5: Build payload
  //     const payload = itemDetailsArray.map((item) => ({
  //       id: item["id"] || 0,
  //       processType: processType,
  //       ot_details_id: 0,
  //       item_id: item["Item Code"] || 0,
  //       item_kit_id: 0,
  //       quantity: 0,
  //       transferDate: new Date().toISOString(),
  //       transferQty: 0,
  //       transferStatus: true,
  //       transferred_by: 0,
  //       issueDate: new Date().toISOString(),
  //       issueStatus: true,
  //       issueQty: 0,
  //       issued_by: 0,
  //       disposedDate: new Date().toISOString(),
  //       disposedQty: Number(item["Disposed Qty"]),
  //       disposed_by: 0,
  //       disposedReason: (item["Disposed Reason"] ?? "").trim() || null,
  //       receiveDate: new Date().toISOString(),
  //       receiveQty: 0,
  //       receiveStatus: true,
  //       received_by: 0,
  //       cleaningStatus: true,
  //       decontaminationStatus: true,
  //       cleanedQty: Number(item["Cleaned Qty"]),
  //       cleaned_by: 0,
  //       cleaningStartDate: new Date().toISOString(),
  //       cleaningEndDate: new Date().toISOString(),
  //       wrappedQty: 0,
  //       wrappingStatus: true,
  //       wrapped_by: 0,
  //       wrapper_type_id: 0,
  //       wrapperTypeQty: 0,
  //       wrapping_method_id: 0,
  //       wrappingStartDate: new Date().toISOString(),
  //       wrappingEndDate: new Date().toISOString(),
  //       sterilizationQty: 0,
  //       sterilizationStatus: true,
  //       sterilizationStatusType: processType,
  //       sterilization_start_by: 0,
  //       sterilizationStartDate: new Date().toISOString(),
  //       sterilizationEndDate: new Date().toISOString(),
  //       sterilization_end_by: 0,
  //       machine_id: 0,
  //       sterilization_type_id: 0,
  //       sterilization_method: 0,
  //       sterilizationExpiryDate: new Date().toISOString(),
  //       addToStockQty: 0,
  //       temperature: 0,
  //       pressure: 0,
  //       durationMinutes: 0,
  //       indicatorResult: "string",
  //       from_store_id: 0,
  //       to_store_id: 0,
  //       itemBatchNo: item["Item BatchNo"] || "string",
  //       kitBatchNo: item["Kit BatchNo"] || "string",
  //       cssdLotNo: "string",
  //       createdBy: "string",
  //       lastModifiedBy: "string",
  //       createdDate: new Date().toISOString(),
  //       lastModifiedDate: new Date().toISOString(),
  //     }));

  //     // 🧩 Step 6: Save payload
  //     const response = await saveTransferCssdItemsParentList(payload);

  //     // 🧩 Step 7: Handle response
  //     if (response?.status === 200) {
  //       successAlert(`Items successfully sent for ${processType}!`);
  //       setOpenPostModal(false);

  //       // Refresh data
  //       if (getItemType === "Item") populateItemTable();
  //       else populateKitTable();

  //       setView("Wrapping & Packaging");
  //     } else {
  //       errorAlert("Failed to send items!");
  //     }
  //   } catch (error) {
  //     console.error("Error sending items:", error);
  //     errorAlert("Something went wrong while sending items.");
  //   } finally {
  //     setOpenBackdrop(false);
  //   }
  // };

  // 1️⃣ Flatten
  const allItems = cleaningKitItemsList.flatMap(kit =>
    kit.kitItemList?.map(item => ({
      ...item,
      KitName: item.KitName,
      parentKitId: kit.id
    })) || []
  );

  useEffect(() => {
    if (!manualUpdate && allItems?.length > 0) {
      const grouped = allItems.reduce((acc, item) => {
        const key = item.kitId ?? 0;
        if (!acc[key]) acc[key] = [];
        acc[key].push(item);
        return acc;
      }, {});

      setGroupedItems(prev => ({ ...grouped, ...prev }));
    }

    setManualUpdate(false);
  }, [allItems]);


  useEffect(() => {
    const updatedTabs = Object.entries(groupedItems).map(([kitId, items]) => ({
      kitId,
      KitName: items?.[0]?.KitName || `Kit ${kitId}`,
      items,
    }));

    setFinalTabs(updatedTabs);
  }, [groupedItems]);


  // const addToStockList = async (selectedProcess) => {
  //   setOpenBackdrop(true); // Show loading

  //   try {
  //     // Get selected items
  //     const itemDetailsArray =
  //       getItemType === "Item"
  //         ? cleaningItemsList?.filter((item) => item.Select)
  //         : cleaningKitItemsList
  //           ?.flatMap((kit) => kit.kitItemList)
  //           ?.filter((item) => item.Select);

  //     if (!itemDetailsArray?.length) {
  //       warningAlert("No items selected to send!");
  //       setOpenBackdrop(false);
  //       return;
  //     }

  //     // ✅ Proper validation for each item
  //     for (const item of itemDetailsArray) {
  //       const cleanedQtyRaw = item["Cleaned Qty"]?.toString().trim() || "";
  //       const disposedQtyRaw = item["Disposed Qty"]?.toString().trim() || "";
  //       const disposedReason = (item["Disposed Reason"] ?? "").trim();

  //       // 1. Check if any field is empty
  //       // if (cleanedQtyRaw === "") {
  //       //   warningAlert(`Please enter Cleaned Qty for item ${item["Item Code"] || ""}`);
  //       //   setOpenBackdrop(false);
  //       //   return;
  //       // }

  //       for (const kit of cleaningKitItemsList) {
  //         for (const item of kit.kitItemList) {
  //           if (!item["Cleaned Qty"] || item["Cleaned Qty"].toString().trim() === "") {
  //             warningAlert(`Please enter Cleaned Qty for item ${item["Item Code"]}`);
  //             return;
  //           }
  //         }
  //       }


  //       // if (disposedQtyRaw === "") {
  //       //   warningAlert(`Please enter Disposed Qty for item ${item["Item Code"] || ""}`);
  //       //   setOpenBackdrop(false);
  //       //   return;
  //       // }

  //       // 2. Convert to numbers
  //       const cleanedQty = Number(cleanedQtyRaw);
  //       const disposedQty = Number(disposedQtyRaw);

  //       // 3. Validate numbers
  //       if (isNaN(cleanedQty) || cleanedQty < 0) {
  //         warningAlert(`Cleaned Qty must be a valid non-negative number for item ${item["Item Code"] || ""}`);
  //         setOpenBackdrop(false);
  //         return;
  //       }

  //       if (isNaN(disposedQty) || disposedQty < 0) {
  //         warningAlert(`Disposed Qty must be a valid non-negative number for item ${item["Item Code"] || ""}`);
  //         setOpenBackdrop(false);
  //         return;
  //       }

  //       // 4. Disposed Reason required if disposedQty > 0
  //       if (disposedQty > 0 && disposedReason === "") {
  //         warningAlert(`Disposed Reason is required when Disposed Qty is greater than 0 for item ${item["Item Code"] || ""}`);
  //         setOpenBackdrop(false);
  //         return;
  //       }
  //     }

  //     // Determine process type
  //     const processTypeMap = {
  //       cleaning: "cleaning",
  //       wrapping: "wrapping",
  //       sterilization: "sterilization",
  //     };
  //     const processType = processTypeMap[selectedProcess] || "cleaning";

  //     // Build payload
  //     const payload = itemDetailsArray.map((item) => ({
  //       id: item["id"] || 0,
  //       processType: processType,
  //       ot_details_id: 0,
  //       item_id: item["Item Code"] || 0,
  //       item_kit_id: 0,
  //       quantity: 0,
  //       transferDate: new Date().toISOString(),
  //       transferQty: 0,
  //       transferStatus: true,
  //       transferred_by: 0,
  //       issueDate: new Date().toISOString(),
  //       issueStatus: true,
  //       issueQty: 0,
  //       issued_by: 0,
  //       disposedDate: new Date().toISOString(),
  //       disposedQty: Number(item["Disposed Qty"]),
  //       disposed_by: 0,
  //       disposedReason: item["Disposed Reason"] || null,
  //       receiveDate: new Date().toISOString(),
  //       receiveQty: 0,
  //       receiveStatus: true,
  //       received_by: 0,
  //       cleaningStatus: true,
  //       decontaminationStatus: true,
  //       cleanedQty: Number(item["Cleaned Qty"]),
  //       cleaned_by: 0,
  //       cleaningStartDate: new Date().toISOString(),
  //       cleaningEndDate: new Date().toISOString(),
  //       wrappedQty: 0,
  //       wrappingStatus: true,
  //       wrapped_by: 0,
  //       wrapper_type_id: 0,
  //       wrapperTypeQty: 0,
  //       wrapping_method_id: 0,
  //       wrappingStartDate: new Date().toISOString(),
  //       wrappingEndDate: new Date().toISOString(),
  //       sterilizationQty: 0,
  //       sterilizationStatus: true,
  //       sterilizationStatusType: processType,
  //       sterilization_start_by: 0,
  //       sterilizationStartDate: new Date().toISOString(),
  //       sterilizationEndDate: new Date().toISOString(),
  //       sterilization_end_by: 0,
  //       machine_id: 0,
  //       sterilization_type_id: 0,
  //       sterilization_method: 0,
  //       sterilizationExpiryDate: new Date().toISOString(),
  //       addToStockQty: 0,
  //       temperature: 0,
  //       pressure: 0,
  //       durationMinutes: 0,
  //       indicatorResult: "string",
  //       from_store_id: 0,
  //       to_store_id: 0,
  //       itemBatchNo: item["Item BatchNo"] || "string",
  //       kitBatchNo: item["Kit Batch No"] || "string",
  //       cssdLotNo: "string",
  //       createdBy: "string",
  //       lastModifiedBy: "string",
  //       createdDate: new Date().toISOString(),
  //       lastModifiedDate: new Date().toISOString(),
  //     }));

  //     // Send payload
  //     const response = await saveTransferCssdItemsParentList(payload);

  //     if (response?.status === 200) {
  //       successAlert(`Items successfully sent for ${processType}!`);
  //       setOpenPostModal(false);

  //       // Refresh tables
  //       if (getItemType === "Item") populateItemTable();
  //       else populateKitTable();

  //       setView("Wrapping & Packaging");
  //     } else {
  //       errorAlert("Failed to send items!");
  //     }
  //   } catch (error) {
  //     console.error("Error sending items:", error);
  //     errorAlert("Something went wrong while sending items.");
  //   } finally {
  //     setOpenBackdrop(false);
  //   }
  // };


  // const addToStockList = async (selectedProcess, formData) => {
  //   setOpenBackdrop(true);

  //   try {
  //     // ---------------------- GET SELECTED ITEMS ----------------------
  //     const itemDetailsArray =
  //       getItemType === "Item"
  //         ? cleaningItemsList?.filter((item) => item.Select)
  //         : cleaningKitItemsList?.flatMap((kit) => kit.kitItemList)?.filter((item) => item.Select);

  //     if (!itemDetailsArray?.length) {
  //       warningAlert("No items selected to send!");
  //       setOpenBackdrop(false);
  //       return;
  //     }

  //     // ---------------------- VALIDATION ----------------------
  //     for (const item of itemDetailsArray) {
  //       const cleanedQtyRaw = item["Cleaned Qty"]?.toString().trim() || "";
  //       const disposedQtyRaw = item["Disposed Qty"]?.toString().trim() || "";
  //       const disposedReason = (item["Disposed Reason"] ?? "").trim();

  //       // Required validation for kit items
  //       for (const kit of cleaningKitItemsList) {
  //         for (const kitItem of kit.kitItemList) {
  //           if (!kitItem["Cleaned Qty"] || kitItem["Cleaned Qty"].toString().trim() === "") {
  //             warningAlert(`Please enter Cleaned Qty for item ${kitItem["Item Code"]}`);
  //             return;
  //           }
  //         }
  //       }

  //       const cleanedQty = Number(cleanedQtyRaw);
  //       const disposedQty = Number(disposedQtyRaw);

  //       if (isNaN(cleanedQty) || cleanedQty < 0) {
  //         warningAlert(`Cleaned Qty must be valid for item ${item["Item Code"]}`);
  //         setOpenBackdrop(false);
  //         return;
  //       }

  //       if (isNaN(disposedQty) || disposedQty < 0) {
  //         warningAlert(`Disposed Qty must be valid for item ${item["Item Code"]}`);
  //         setOpenBackdrop(false);
  //         return;
  //       }

  //       if (disposedQty > 0 && disposedReason === "") {
  //         warningAlert(`Disposed Reason is required for item ${item["Item Code"]}`);
  //         setOpenBackdrop(false);
  //         return;
  //       }
  //     }

  //     // ---------------------- GET FIRST TABLE SELECTED ID ----------------------
  //     const parentTableId =
  //       getItemType === "Item"
  //         ? cleaningItemsList?.find(item => item.Select)?.id || 0
  //         : cleaningKitList?.find(item => item.Select)?.id || 0;

  //     // ---------------------- PROCESS TYPE (FINAL SINGLE VALUE) ----------------------
  //     const processTypeMap = {
  //       cleaning: "cleaning",
  //       wrapping: "wrapping",
  //       sterilization: "sterilization",
  //     };

  //     const processType = processTypeMap[selectedProcess] || "cleaning";

  //     const getId = (value) => Number(value?.id || value || 0);

  //     // ---------------------- BUILD PAYLOAD ----------------------
  //     const payload = [
  //       {
  //         id: parentTableId,
  //         surgeon_id: getId(formData.surgeonName),
  //         handover_by_id: getId(formData?.handoverBy),
  //         received_by_id: getId(formData?.receivedBy),
  //         remark: formData?.remark?.trim() || "",

  //         cssdUpdateReqest: itemDetailsArray.map((item) => ({
  //           id: item.id || 0,
  //           processType: processType,
  //           item_id: item["Item Code"] || 0,
  //           cleanedQty: Number(item["Cleaned Qty"]) || 0,
  //           disposedQty: Number(item["Disposed Qty"]) || 0,
  //           disposedReason: item["Disposed Reason"] || "",
  //           createdDate: new Date().toISOString(),
  //           lastModifiedDate: new Date().toISOString(),
  //         })),
  //       },
  //     ];

  //     console.log("📤 FINAL PAYLOAD SENT:", JSON.stringify(payload, null, 2));

  //     // ---------------------- API CALL ----------------------
  //     const response = await saveTransferCssdItemsParentList(payload);

  //     if (response?.status === 200) {
  //       successAlert(`Items successfully sent for ${processType}!`);
  //       setOpenPostModal(false);

  //       getItemType === "Item" ? populateItemTable() : populateKitTable();

  //       setView("Wrapping & Packaging");
  //     } else {
  //       errorAlert("Failed to send items!");
  //     }

  //   } catch (error) {
  //     console.error("❌ Error sending items:", error);
  //     errorAlert("Something went wrong while sending items.");
  //   } finally {
  //     setOpenBackdrop(false);
  //   }
  // };


  const addToStockList = async (selectedProcess, formData) => {
    setOpenBackdrop(true);

    try {
      // 🔥 SOURCE OF TRUTH = UPDATED TABLE (UI)
      const itemDetailsArray =
        getItemType === "Item"
          ? cleaningItemsList.map(item => ({
            ...item,
            kitId: item.kitId || 0,
          }))
          : finalTabs.flatMap(tab =>
            tab.items
              .filter(item => !item.isHidden)   // ✅ ADD THIS LINE
              .map(item => ({
                ...item,
                kitId: Number(tab.kitId),
                KitName: tab.KitName,
              }))
          );


      if (!itemDetailsArray?.length) {
        warningAlert("No items available to send!");
        return;
      }

      // ✅  Start CLEANED QTY ONLY VALIDATION
      const cleanedQtyErrors = [];

      itemDetailsArray.forEach((item, index) => {
        const cleanedQty = Number(item["Cleaned Qty"]);

        if (!cleanedQty || isNaN(cleanedQty) || cleanedQty <= 0) {
          cleanedQtyErrors.push(
            `Row ${index + 1}: Cleaned Qty must be greater than 0`
          );
        }
      });

      if (cleanedQtyErrors.length) {
        warningAlert(cleanedQtyErrors.join("\n"));
        setOpenBackdrop(false);
        return;
      }

      // const disposedQtyErrors = [];

      // itemDetailsArray.forEach((item, index) => {
      //   const disposedQty = Number(item["Disposed Qty"]);

      //   if (!disposedQty || isNaN(disposedQty) || disposedQty <= 0) {
      //     disposedQtyErrors.push(
      //       `Row ${index + 1}: Disposed Qty must be greater than 0`
      //     );
      //   }
      // });

      // if (disposedQtyErrors.length) {
      //   warningAlert(disposedQtyErrors.join("\n"));
      //   setOpenBackdrop(false);
      //   return;
      // }

      // End 

      // Parent table id (kit or item header)
      const parentTableId =
        getItemType === "Item"
          ? cleaningItemsList?.[0]?.id || 0
          : cleaningKitList?.find(k => k.Select)?.id || 0;

      // Always cleaning here
      const processType = "cleaning";

      const getId = (value) => Number(value?.id || value || 0);

      const payload = [
        {
          id: parentTableId,
          surgeon_id: getId(formData?.surgeonName),
          handover_by_id: getId(formData?.handoverBy),
          received_by_id: getId(formData?.receivedBy),
          remark: formData?.remark?.trim() || "",

          cssdUpdateReqest: itemDetailsArray.map(item => ({
            id: item.id || 0,
            processType,

            ot_details_id: 0,
            item_id: Number(item["Item Code"] || 0),
            // item_kit_id: Number(item.kitId || 0),
            item_kit_id: item.kitId ?? item["kitId"] ?? 0,

            cleanedQty: Number(item["Cleaned Qty"] || 0),
            disposedQty: Number(item["Disposed Qty"] || 0),
            disposedReason: (item["Disposed Reason"] ?? "").trim(),

            kitBatchNo: item.kitBatchNo || "",
            itemBatchNo: item["Item BatchNo"] || "",

            cleaningStatus: true,
            decontaminationStatus: true,

            cleaningStartDate: new Date().toISOString(),
            cleaningEndDate: new Date().toISOString(),
            createdDate: new Date().toISOString(),
            lastModifiedDate: new Date().toISOString(),

            // defaults required by backend
            quantity: 0,
            transferDate: new Date().toISOString(),
            transferQty: 0,
            transferStatus: true,
            transferred_by: 0,
            issueDate: new Date().toISOString(),
            issueStatus: true,
            issueQty: 0,
            issued_by: 0,
            disposedDate: new Date().toISOString(),
            disposed_by: 0,
            receiveDate: new Date().toISOString(),
            receiveQty: 0,
            receiveStatus: true,
            received_by: 0,
            wrappedQty: 0,
            wrappingStatus: true,
            wrapped_by: 0,
            wrapper_type_id: 0,
            wrapperTypeQty: 0,
            wrapping_method_id: 0,
            wrappingStartDate: new Date().toISOString(),
            wrappingEndDate: new Date().toISOString(),
            sterilizationQty: 0,
            sterilizationStatus: true,
            sterilizationStatusType: processType,
            sterilization_start_by: 0,
            sterilizationStartDate: new Date().toISOString(),
            sterilizationEndDate: new Date().toISOString(),
            sterilization_end_by: 0,
            machine_id: 0,
            sterilization_type_id: 0,
            sterilization_method: 0,
            sterilizationExpiryDate: new Date().toISOString(),
            addToStockQty: 0,
            temperature: 0,
            pressure: 0,
            durationMinutes: 0,
            indicatorResult: "string",
            from_store_id: 0,
            to_store_id: 0,
            cssdLotNo: "string",
            createdBy: "string",
            lastModifiedBy: "string",
          })),
        },
      ];

      console.log(
        "📤 FINAL PAYLOAD (UI MATCH):",
        JSON.stringify(payload, null, 2)
      );

      const response = await saveTransferCssdItemsParentList(payload);

      if (response?.status === 200) {
        successAlert("Items successfully sent for cleaning!");
        setOpenPostModal(false);

        getItemType === "Item" ? populateItemTable() : populateKitTable();
        setView("Wrapping & Packaging");
      } else {
        errorAlert("Failed to send items!");
      }
    } catch (error) {
      console.error("❌ Error sending items:", error);
      errorAlert("Something went wrong while sending items.");
    } finally {
      setOpenBackdrop(false);
    }
  };

  // const addToStockList = async (selectedProcess, formData) => {
  //   setOpenBackdrop(true);

  //   try {
  //     const itemDetailsArray =
  //       getItemType === "Item"
  //         ? cleaningItemsList?.filter((item) => item.Select)
  //         : cleaningKitItemsList?.flatMap((kit) => kit.kitItemList)?.filter((item) => item.Select);

  //     if (!itemDetailsArray?.length) {
  //       warningAlert("No items selected to send!");
  //       setOpenBackdrop(false);
  //       return;
  //     }

  //     const parentTableId =
  //       getItemType === "Item"
  //         ? cleaningItemsList?.find(item => item.Select)?.id || 0
  //         : cleaningKitList?.find(item => item.Select)?.id || 0;

  //     // 🔥 FORCE PROCESS TYPE AS CLEANING ALWAYS
  //     const processType = "cleaning";

  //     const getId = (value) => Number(value?.id || value || 0);

  //     const payload = [
  //       {
  //         id: parentTableId,
  //         surgeon_id: getId(formData.surgeonName),
  //         handover_by_id: getId(formData?.handoverBy),
  //         received_by_id: getId(formData?.receivedBy),
  //         remark: formData?.remark?.trim() || "",

  //         cssdUpdateReqest: itemDetailsArray.map((item) => ({
  //           id: item["id"] || 0,
  //           processType: processType,
  //           ot_details_id: 0,
  //           item_id: item["Item Code"] || 0,
  //           item_kit_id: item["kitId"] || 0,
  //           quantity: 0,
  //           transferDate: new Date().toISOString(),
  //           transferQty: 0,
  //           transferStatus: true,
  //           transferred_by: 0,
  //           issueDate: new Date().toISOString(),
  //           issueStatus: true,
  //           issueQty: 0,
  //           issued_by: 0,
  //           disposedDate: new Date().toISOString(),
  //           disposedQty: Number(item["Disposed Qty"]),
  //           disposed_by: 0,
  //           disposedReason: (item["Disposed Reason"] ?? "").trim() || null,
  //           receiveDate: new Date().toISOString(),
  //           receiveQty: 0,
  //           receiveStatus: true,
  //           received_by: 0,
  //           cleaningStatus: true,
  //           decontaminationStatus: true,
  //           cleanedQty: Number(item["Cleaned Qty"]),
  //           cleaned_by: 0,
  //           cleaningStartDate: new Date().toISOString(),
  //           cleaningEndDate: new Date().toISOString(),
  //           wrappedQty: 0,
  //           wrappingStatus: true,
  //           wrapped_by: 0,
  //           wrapper_type_id: 0,
  //           wrapperTypeQty: 0,
  //           wrapping_method_id: 0,
  //           wrappingStartDate: new Date().toISOString(),
  //           wrappingEndDate: new Date().toISOString(),
  //           sterilizationQty: 0,
  //           sterilizationStatus: true,
  //           sterilizationStatusType: processType,
  //           sterilization_start_by: 0,
  //           sterilizationStartDate: new Date().toISOString(),
  //           sterilizationEndDate: new Date().toISOString(),
  //           sterilization_end_by: 0,
  //           machine_id: 0,
  //           sterilization_type_id: 0,
  //           sterilization_method: 0,
  //           sterilizationExpiryDate: new Date().toISOString(),
  //           addToStockQty: 0,
  //           temperature: 0,
  //           pressure: 0,
  //           durationMinutes: 0,
  //           indicatorResult: "string",
  //           from_store_id: 0,
  //           to_store_id: 0,
  //           itemBatchNo: item["Item BatchNo"] || "string",
  //           kitBatchNo: item["kitBatchNo"] || "string",
  //           cssdLotNo: "string",
  //           createdBy: "string",
  //           lastModifiedBy: "string",
  //           createdDate: new Date().toISOString(),
  //           lastModifiedDate: new Date().toISOString(),
  //         })),
  //       },
  //     ];

  //     console.log("📤 FINAL PAYLOAD SENT:", JSON.stringify(payload, null, 2));

  //     const response = await saveTransferCssdItemsParentList(payload);

  //     if (response?.status === 200) {
  //       successAlert(`Items successfully sent for cleaning!`);
  //       setOpenPostModal(false);

  //       getItemType === "Item" ? populateItemTable() : populateKitTable();
  //       setView("Wrapping & Packaging");
  //     } else {
  //       errorAlert("Failed to send items!");
  //     }
  //   } catch (error) {
  //     console.error("❌ Error sending items:", error);
  //     errorAlert("Something went wrong while sending items.");
  //   } finally {
  //     setOpenBackdrop(false);
  //   }
  // };


  console.log("cleaningItemsList", cleaningItemsList);

  const handleItemKitChange = (autoSearchString) => {
    if (
      autoSearchString !== "" &&
      UseCheckConsecutiveCharacters(autoSearchString)
    ) {
      setSearchBarString(autoSearchString);
      autoSearchCssdItemKit(autoSearchString, "cssd")
        .then((response) => response.data)
        .then((res) => {
          setItemKitOptions(res.result);
        });
    } else if (autoSearchString === "") {
      setSearchBarString("");
      setItemKitOptions([]);
    }
  };

  const selectedSearchBarValue = (value) => {
    if (value !== null) {
      setSearchBarId(value?.id);
      setSearchBarString("");
    } else {
      setSearchBarId(null);
    }
  };



  const handleAddKitItemChange = (autoSearchString, actionMeta) => {

    if (!autoSearchString) return autoSearchString; // must return something

    if (addType === "kit") {
      autoSearchCssdItemKit(autoSearchString, "cssd")
        .then((res) => setModalItemKitOptions(res.data.result));
    } else {
      autoSearchCssdItemItem(autoSearchString, "cssd")
        .then((res) => setModalItemItemOptions(res.data.result));
    }

    return autoSearchString; // IMPORTANT → needed by react-select
  };

  const handleReceiveCSSDSearch = async () => {
    try {
      const payload = {
        searchString: watch("searchByItem") || null,
        page: kitPage,
        size: kitRowsPerPage,
        fromDate: format(getFromDate, "yyyy-MM-dd"),
        toDate: format(getToDate, "yyyy-MM-dd"),
        searchId: null,
        processType: "cleaning",
        storeId: watch("fromStore")?.value ?? null
      };

      console.log("cleaning Payload:", payload);

      const res = await fetchTransferCssdItemsKitListCSSDRe(payload);

      const tableData = (res?.data?.result || []).map(item => ({
        Select: false,
        ...item
      }));

      setCleaningKitList(tableData);

    } catch (error) {
      console.error("cleaning API Error:", error);
    }
  };

  // useMemo(() => {
  //   if (getItemType === "Item") {
  //     populateItemTable();
  //     setCleaningKitList([]);
  //     setCleaningKitItemsList([]);
  //   } else if (getItemType === "Kit") {
  //     populateKitTable();
  //     setCleaningKitItemsList([]);
  //     setCleaningItemsList([]);
  //   }
  // }, [getItemType]);

  useMemo(() => {
    populateKitTable();
    setCleaningKitItemsList([]);
    setCleaningItemsList([]);
  }, [
    kitListingObject?.fromDate,
    kitListingObject?.toDate,
    kitListingObject?.searchId,
    kitListingObject?.searchString,
  ]);

  useEffect(() => {
    setFormData(prev => ({
      ...prev,
      surgeonName: watch("surgeonName"),
      handoverBy: watch("handoverBy"),
      receivedBy: watch("receivedBy"),
      remark: watch("remark"),
    }));
  }, [watch("surgeonName"), watch("handoverBy"), watch("receivedBy"), watch("remark")]);



  useEffect(() => {
    // useGetUserActions(location?.state?.menuId).then((response) => {
    //   setUserActions(response);
    // });

    // getStoreDropdown(getUserInfo?.loginUnitId).then((response) => {
    //   setStoreOptions(response.data?.result);
    // });

    // autoSearchSurgeonName(getUserInfo?.loginUnitId).then((response) => {
    //   setSurgeonOptions(response.data?.result);
    // });

    // autoSearchHandoverReceived(getUserInfo?.loginUnitId).then((response) => {
    //   const empList = response.data?.result || [];
    //   setHandoverOptions(empList);
    //   setReceivedOptions(empList);
    // });
  }, []);


  console.log("cleaningKitList", cleaningKitList);

  console.log("kitCount", kitCount);

  return (
    <div className="px-4">
      <div className="grid grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-5 gap-3 mt-2">

        <SearchDropdown
          control={control}
          name="surgeonName"
          placeholder="Surgeon Name"
          dataArray={surgeonOptions}
          inputValue={searchBarString}
          isClearable
          handleInputChange={handleSurgeonNameChange}
          onChange={(selected) => {
            console.log("Selected surgeon:", selected);
          }}
        />

        <SearchDropdown
          control={control}
          name="handoverBy"
          placeholder="Handover By"
          dataArray={handoverOptions}
          inputValue={searchBarString}
          isClearable
          handleInputChange={handlehandoverByChange}
          onChange={(selected) => {
            console.log("Selected handoverBy:", selected);
          }}
        />

        <SearchDropdown
          control={control}
          name="receivedBy"
          placeholder="Received By"
          dataArray={receivedOptions}
          inputValue={searchBarString}
          isClearable
          handleInputChange={handlereceivedOptionsChange}
          onChange={(selected) => {
            console.log("Selected receivedBy:", selected);
          }}
        />

        <div className="col-span-1 sm:col-span-2 lg:col-span-2">
          <Controller
            name="remark"
            control={control}
            render={({ field }) => (
              <div className="relative w-full">
                <textarea
                  {...field}
                  rows={1}
                  placeholder="Enter remark..."
                  className="peer w-full border border-gray-300 rounded px-3 py-2 text-sm focus:outline-none focus:ring-2
                 focus:ring-customBlue focus:border-customBlue h-9"
                />

                <label
                  className="
                  absolute left-3 top-3 text-gray-500 text-sm
                  transition-all duration-200 ease-in-out
                  pointer-events-none
                  peer-focus:-top-2 peer-focus:text-xs peer-focus:text-customBlue
                  peer-not-placeholder-shown:-top-2 peer-not-placeholder-shown:text-xs
                  min-h-[30px]  
                  "
                >
                </label>
              </div>
            )}
          />
        </div>

      </div>

      <div className="grid grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-5 gap-3 mt-2">
        <SearchBar
          name="searchByItem"
          placeholder="Search By Item / Kit Name"
          searchIcon={true}
          isClearable={true}
          handleInputChange={handleItemKitChange}
          dataArray={itemKitOptions}
          onChange={selectedSearchBarValue}
        />
        <div className="grid grid-cols-2 gap-2">
          <DatePickerField
            control={control}
            name="fromDate"
            label="From Date"
            inputFormat="dd-MM-yyyy"
          />
          <DatePickerField
            control={control}
            name="toDate"
            label="To Date"
            inputFormat="dd-MM-yyyy"
          />
        </div>

        <SearchDropdown
          control={control}
          name="fromStore"
          placeholder="From Store"
          dataArray={storeOptions}
          inputValue={searchBarString}
          isClearable
          handleInputChange={handleFromStoreChange}
          onChange={(selected) => {
            console.log("Selected fromStore:", selected);
          }}
        />

        <div className="flex justify-between space-x-2 lg:col-span-3  xl:col-span-1 2xl:col-span-2">
          <div className="flex space-x-2">
            <CommonButton
              type="button"
              searchIcon={true}
              className="bg-customBlue text-white"
              // onClick={() => {
              //   setKitListingObject((kitListingObject) => ({
              //     ...kitListingObject,
              //     fromDate: getFromDate
              //       ? format(getFromDate, "dd-MM-yyyy")
              //       : null,
              //     toDate: getToDate ? format(getToDate, "dd-MM-yyyy") : null,
              //     searchId: searchBarId ? searchBarId : null,
              //     searchString: searchBarString ? searchBarString : "",
              //   }));
              // }}
              onClick={handleReceiveCSSDSearch}
            />
            <CommonButton
              type="button"
              label="Reset"
              className="border border-customRed text-customRed"
              onClick={() => {
                setKitListingObject((kitListingObject) => ({
                  ...kitListingObject,
                  searchId: null,
                  searchString: "",
                  fromDate: null,
                  toDate: null,
                }));
                setValue("fromDate", null);
                setValue("toDate", null);
                setSearchBarId(null);
                setSearchBarString("");
              }}
            />
          </div>
          <div className="flex gap-1">
            {/* <CommonButton
              type="button"
              label="Add Kit"
              className="border border-customBlue text-customBlue"
              onClick={() => {
                setAddType("kit");
                setOpenAddKitModal(true);
              }}
            /> */}
            <CommonButton
              type="button"
              label="Add Item"
              className="border border-customBlue text-customBlue"
              onClick={() => {
                setAddType("item");
                setOpenAddKitModal(true);
              }}
            />
          </div>

        </div>
      </div>

      <div className="grid lg:grid-cols-2 justify-between">
        <div className="flex space-x-2 items-center mt-3">
          <fieldset className="hidden">
            <RadioField
              control={control}
              name="itemType"
              dataArray={itemType}
            />
          </fieldset>
          {getItemType === "Kit" ? (
            <div className="w-80 hidden">
              <SearchDropdown
                control={control}
                searchIcon={true}
                name="itemKit"
                dataArray={itemKitOptions}
                isSearchable={true}
                placeholder="Search Item Kit"
                isClearable={true}
                handleInputChange={handleItemKitChange}
              />
            </div>
          ) : (
            <div className="w-80 hidden">
              <SearchDropdown
                control={control}
                searchIcon={true}
                name="itemKit"
                // dataArray={itemKitOptions}
                isSearchable={true}
                placeholder="Search Item Name"
                isClearable={true}
              // handleInputChange={handleItemKitChange}
              />
            </div>
          )}
          <CommonButton
            type="button"
            searchIcon={true}
            className="bg-customBlue text-white hidden"
          />
        </div>
        <div className="">
          {cleaningKitItemsList?.length > 0 && (
            // <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
            //   <Tabs
            //     value={values}
            //     onChange={handleChange}
            //     aria-label="basic tabs example"
            //     variant="scrollable"
            //   >
            //     {cleaningKitItemsList?.map((val, ind) => (
            //       <Tab label={val?.KitName} {...a11yProps(ind)} />
            //     ))}
            //   </Tabs>
            // </Box>
            // <div className="flex space-x-4 border-b border-gray-300">
            //   {finalTabs.map((tab, index) => (
            //     <button
            //       key={index}
            //       className={`px-3 py-1 font-semibold ${values === index
            //         ? "text-customBlue border-b-2 border-customBlue"
            //         : "text-gray-500"
            //         }`}
            //       onClick={() => {
            //         requestAnimationFrame(() => setValues(index)); // ensures UI sync
            //       }}
            //     >
            //       {tab.KitName || `Kit ${tab.kitId}`}
            //     </button>
            //   ))}
            // </div>
            <div className="flex space-x-4 border-b border-gray-300">
              {finalTabs.map((tab, index) => (
                <button
                  key={index}
                  onClick={() => setValues(index)}
                  className={`px-3 py-1 font-semibold transition-all ${values === index
                    ? "text-customBlue border-b-2 border-customBlue"
                    : "text-gray-500 hover:text-black"
                    }`}
                >
                  {tab.KitName || `Kit ${tab.kitId}`}
                </button>
              ))}
            </div>

          )}
        </div>
      </div>
      {getItemType === "Kit" ? (
        <div className="grid xl:grid-cols-2 xl:gap-x-2">
          {cleaningKitList?.length > 0 ? (
            <CommonTransactionTable
              dataResult={cleaningKitList}
              page={kitPage}
              setPage={setKitPage}
              count={kitCount}
              rowsPerPage={kitRowsPerPage}
              renderInput={renderInputKit}
              populateTable={populateKitTable}
              editableColumns={["Select"]}
              highlightRow={false}
              tableClass={"h-96"}
              removeHeaders={[
                "Id",
                "createdBy",
                "cssdLotNo",
                "Sr No",
                "Created Date",
                "from_store_id",
                "unit_id",
                // "unit_id",
                // "from_store_id",
                "to_store_id",
                // "to_store_id",
                "discardedQuantity",
                // "discardedQuantity",
                "transitQuantity",
                // "transitQuantity",
                "lastModifiedBy",
                // "Last Modified Date",
                // "cssdLotNo",
                // "Created By",
                "ot_details_id",
                // "ot_details_id",
                "Last Modified By",
                "Item Id",
                "Item Code",
                "Item Name",
                "Ot Details Id",
                "Receive Date",
                "Status",
                "transferDate",
                // "Transfer Date",
                "Received By",
                "Sent By",
                "Cleaned Qty",
                "Cleaning Status",
                "Decontamination Status",
                "Receive Qty",
                "Sterilization Qty",
                "Sterilization Status",
                "transferQty",
                // "Transfer Qty",
                "Wrapped Qty",
                "Wrapping Status",
                "Cleaned By",
                "Wrapped By",
                "Sterilized By",
                "Receive Status",
                "Sterilization Status Type",
                "transferStatus",
                // "Transfer Status",
                "Sterilization End By",
                "Sterilization Start By",
                "transferred_by",
                // "Transferred By",
                "Used Quantity",
                "Sterilization ExpiryDate",
                "AddToStock Qty",
                "Cleaning Start Date",
                "Cleaning End Date",
                "Wrapping Start Date",
                "Wrapping End Date",
                "Sterilization Equipment Id",
                "Machine Id",
                "Machine Name",
                "Sterilization Start Date",
                "Sterilization End Date",
                "Sterilization Equipment",
                "Sterilization Method Id",
                "Sterilization Method",
                "Wrapper Type Id",
                "Wrapper Type",
                "Wrapping Method Id",
                "Wrapping Method",
                "Issue Date",
                "issuedQuantity",
                // "Issue Qty",
                "Issue Status",
                "Issued By",
                "Disposed Date",
                "Disposed Qty",
                "Disposed By",
                "Disposed Reason",
                "Item BatchNo",
                "Temperature",
                "Pressure",
                "Cssd Transfer Id",
              ]}
            />
          ) : (
            <div className="my-2 w-full h-96 flex justify-center items-center font-semibold border border-gray-300 rounded">
              No Records Found...
            </div>
          )}

          {finalTabs?.length > 0 ? (
            <div className="mt-1 p-0">
              {finalTabs.map((kit, index) =>
                index === values ? (
                  <div key={index} className="mt-1 p-0">
                    <div className="flex justify-between font-semibold text-sm bg-[#F1F1F1] px-2 py-1">
                      <label>{kit.KitName}</label>
                      <label>Items Qty : {kit.items?.length}</label>
                    </div>
                    {kit?.items?.length > 0 ? (
                      <CommonTransactionTable
                        dataResult={kit.items}
                        tableClass="-mt-1 h-96"
                        renderInput={renderInputKitItem}
                        editableColumns={[
                          "Select",
                          "Delete",
                          "Disposed Reason",
                          "Item BatchNo",
                        ]}
                        highlightRow={false}
                        removeHeaders={[
                          // "id",
                          "id",
                          // "kitId",
                          "kitId",
                          "Transfer Date",
                          "Receive Date",
                          "Transferred By",
                          "Received By",
                          "Ot Details Id",
                          "Item Id",
                          "Created Date",
                          "Last Modified Date",
                          "Cleaning Status",
                          "Decontamination Status",
                          "Sterilization Qty",
                          "Sterilization Status",
                          "Wrapped Qty",
                          "Wrapping Status",
                          "Cleaned By",
                          "Wrapped By",
                          "Sterilized By",
                          "Receive Status",
                          "Sterilization Status Type",
                          "Transfer Status",
                          "Sterilization End By",
                          "Sterilization Start By",
                          "Transferred By",
                          "Id",
                          "Created Date",
                          "Created By",
                          "Last Modified By",
                          "Status",
                          "Sent By",
                          "Used Quantity",
                          "Transfer Qty",
                          "Sterilization Method Id",
                          "Sterilization Method Name",
                          "Sterilization Equipment Id",
                          "Sterilization Equipment Name",
                          "Wrapper Type Name",
                          "Wrapper Type Id",
                          "Wrapping Method Name",
                          "Wrapping Method Id",
                          "Sterilization ExpiryDate",
                          "AddToStock Qty",
                          "Sterilization Start Date",
                          "Sterilization End Date",
                          "Wrapper Type",
                          "Wrapping Method",
                          "Machine Id",
                          "Machine Name",
                          "Wrapping Start Date",
                          "Wrapping End Date",
                          "Sr No",
                          "Item Kit Code",
                          "Cleaning Start Date",
                          "Cleaning End Date",
                          "Issue Date",
                          "Issue Qty",
                          "Issue Status",
                          "Issued By",
                          "Disposed Date",
                          "Disposed By",
                          "Item Kit Name",
                          "Old Cleaned Qty",
                          "Kit BatchNo",
                          "Temperature",
                          "Pressure",
                          "newBatch",
                          "batchNoList",
                          "CSSD LotNo",
                          "Cssd Transfer Id",
                        ]}
                      />
                    ) : (
                      <div className="w-full h-60 flex justify-center items-center font-semibold border border-gray-300 rounded">
                        No items found against kit...!
                      </div>
                    )}
                  </div>
                ) : null
              )}
            </div>
          ) : (
            <div className="my-2 w-full h-96 flex justify-center items-center font-semibold border border-gray-300 rounded">
              No Records Found...
            </div>
          )}
        </div>
      ) : (
        <div>
          {cleaningItemsList?.length > 0 ? (
            <CommonTransactionPaginationTable
              dataResult={cleaningItemsList}
              page={page}
              setPage={setPage}
              count={count}
              rowsPerPage={rowsPerPage}
              tableHeading={"Item List"}
              renderInput={renderInputItem}
              populateTable={populateItemTable}
              editableColumns={[
                "Select",
                "Cleaned Qty",
                "Disposed Qty",
                "Disposed Reason",
              ]}
              highlightRow={false}
              removeHeaders={[
                "Transfer Date",
                "Receive Date",
                "Transferred By",
                "Received By",
                "Ot Details Id",
                "Item Id",
                "Created Date",
                "Last Modified Date",
                "Cleaning Status",
                "Decontamination Status",
                "Sterilization Qty",
                "Sterilization Status",
                "Wrapped Qty",
                "Wrapping Status",
                "Cleaned By",
                "Wrapped By",
                "Sterilized By",
                "Receive Status",
                "Sterilization Status Type",
                "Transfer Status",
                "Sterilization End By",
                "Sterilization Start By",
                "Transferred By",
                "Id",
                "Created Date",
                "Created By",
                "Last Modified By",
                "Status",
                "Sent By",
                "Used Quantity",
                "Transfer Qty",
                "Sterilization Method Id",
                "Sterilization Method Name",
                "Sterilization Equipment Id",
                "Sterilization Equipment Name",
                "Wrapper Type Name",
                "Wrapper Type Id",
                "Wrapping Method Name",
                "Wrapping Method Id",
                "Sterilization ExpiryDate",
                "AddToStock Qty",
                "Sterilization Start Date",
                "Sterilization End Date",
                "Wrapping Method",
                "Wrapper Type",
                "Sterilization Equipment",
                "Sterilization Method",
                "Machine Id",
                "Machine Name",
                "Wrapping Start Date",
                "Wrapping End Date",
                "Sr No",
                "Item Kit Code",
                "Cleaning Start Date",
                "Cleaning End Date",
                "Issue Date",
                "Issue Qty",
                "Issue Status",
                "Issued By",
                "Disposed Date",
                "Disposed By",
                "Item Kit Name",
                "Old Cleaned Qty",
                "Kit BatchNo",
                "Temperature",
                "Pressure",
                "CSSD LotNo",
                "Cssd Transfer Id",
              ]}
            />
          ) : (
            <div className="my-2 w-full h-96 flex justify-center items-center font-semibold border border-gray-300 rounded">
              No Records Found...
            </div>
          )}
        </div>
      )}
      {/*   <div className="flex justify-end">
        <CommonButton
          type="button"
          label={"Send To Wrapping"}
          className="bg-customGreen text-white"
          onClick={() => {
            let itemDetailsArray =
              getItemType === "Item"
                ? cleaningItemsList?.filter((fil) => fil.Select === true)
                : cleaningKitItemsList
                  ?.flatMap((val) => val?.kitItemList)
                  ?.filter((fil) => fil.Select === true);
            if (itemDetailsArray?.length > 0) {
              setOpenPostModal(true);
            } else if (itemDetailsArray?.length === 0) {
              warningAlert("Select items for cleaning...!");
            }
            addToStockList(selectedProcess, formData);

          }}
        // onClick={() => {
        //   const itemDetailsArray =
        //     getItemType === "Item"
        //       ? cleaningItemsList?.filter((item) => item.Select)
        //       : cleaningKitItemsList?.flatMap((kit) => kit.kitItemList)?.filter((item) => item.Select);

        //   if (!itemDetailsArray?.length) {
        //     warningAlert("Select items for cleaning!");
        //     return;
        //   }

        //   // 🔥 Pass form data into addToStockList
        //   addToStockList(selectedProcess, formData);
        // }}
        />
      </div> */}

      <div className="flex justify-end">
        <CommonButton
          type="button"
          label="Send To Wrapping"
          className="bg-customGreen text-white"
          onClick={() => {
            const itemDetailsArray =
              getItemType === "Item"
                ? cleaningItemsList?.filter((fil) => fil.Select === true)
                : cleaningKitItemsList
                  ?.flatMap((val) => val?.kitItemList)
                  ?.filter((fil) => fil.Select === true);

            if (itemDetailsArray?.length > 0) {
              setOpenPostModal(true); // Just open confirmation modal
            } else {
              warningAlert("Select items for cleaning...!");
            }
          }}
        />
      </div>

      <CommonBackDrop openBackdrop={openBackdrop} />
      {/* {openKitModal && (
        <Modal open={openKitModal}>
          <Box sx={ModalStyle} className="max-w-[50%] space-y-2">
            <div className="flex justify-between">
              <label className="font-semibold">Add New Kit</label>
              <button
                type="button"
                onClick={() => {
                  setOpenAddKitModal(false);
                  setValue("addKitItemSearch", null);
                }}
              >
                <CloseModalIcon />
              </button>
            </div>
            <div className="flex space-x-2">
              <div className="w-80">
                <SearchDropdown
                  control={control}
                  searchIcon={true}
                  name="addKitItemSearch"
                  // dataArray={modalItemKitOptions}
                  dataArray={[...modalItemKitOptions, ...modalItemItemOptions]}
                  isSearchable={true}
                  placeholder="Search Item Kit"
                  isClearable={true}
                  handleInputChange={handleAddKitItemChange}
                  menuPlacement="bottom"
                  inputRef={{
                    ...register("addKitItemSearch", {
                      onChange: (e) => {
                        if (e.target.value?.batchno === null) {
                          getBatchWiseCssdKits(
                            getUserInfo?.loginUnitId,
                            e.target.value?.id
                          ).then((response) => {
                            console.log("response321", response);
                            setNewKitBatch(
                              response?.data?.result[0]?.kitbatchno
                            );
                            setExistKitBatch("");
                          });
                        } else {
                          setExistKitBatch(e?.target?.value?.batchno);
                          setNewKitBatch("");
                        }
                      },
                    }),
                  }}
                />
              </div>
              <CommonButton
                type="button"
                label="Add"
                className="border border-customBlue text-customBlue"
                onClick={() => {
                  let kitBatch =
                    newKitBatch !== "" ? newKitBatch : existKitBatch;
                  let duplicateKit = cleaningKitList?.some(
                    (val) =>
                      val?.["Kit BatchNo"] === kitBatch &&
                      val?.["Item Kit Code"] === getAddKitItemSearch?.id
                  );
                  if (getAddKitItemSearch && !duplicateKit) {
                    setCleaningKitList([
                      ...cleaningKitList,
                      {
                        Select: false,
                        "Item Kit Code": getAddKitItemSearch?.id,
                        "Item Kit Name": getAddKitItemSearch?.label,
                        "Kit BatchNo":
                          newKitBatch !== "" ? newKitBatch : existKitBatch,
                        newBatch: newKitBatch !== "" ? true : false,
                        "Sr No":
                          newKitBatch !== "" ? newKitBatch : existKitBatch,
                      },
                    ]);
                    setOpenAddKitModal(false);
                    setKitCount(kitCount !== null ? kitCount + 1 : 1);
                    setValue("addKitItemSearch", null);
                    setNewKitBatch("");
                    setExistKitBatch("");
                  } else if (duplicateKit) {
                    warningAlert("Kit already exists...!");
                  } else if (
                    getAddKitItemSearch === null ||
                    getAddKitItemSearch === undefined
                  ) {
                    warningAlert("Select kit to add...!");
                  }
                }}
              />
            </div>
          </Box>
        </Modal>
      )} */}

      {/* {openKitModal && (
        <Modal open={openKitModal}>
          <Box sx={ModalStyle} className="w-[25%] h-[50%] space-y-2">
            <div className="flex justify-between">
              <label className="font-semibold">
                {addType === "kit" ? "Add New Kit" : "Add New Item"}
              </label>

              <button
                type="button"
                onClick={() => {
                  setOpenAddKitModal(false);
                  setValue("addKitItemSearch", null);
                }}
              >
                <CloseModalIcon />
              </button>
            </div>

            <div className="flex space-x-2">
              <div className="w-80">
                <SearchDropdown
                  control={control}
                  searchIcon={true}
                  name="addKitItemSearch"
                  dataArray={
                    addType === "kit"
                      ? modalItemKitOptions
                      : modalItemItemOptions
                  }

                  isSearchable={true}
                  placeholder={
                    addType === "kit"
                      ? "Search Item Kit"
                      : "Search Item"
                  }
                  isClearable={true}
                  handleInputChange={handleAddKitItemChange}

                  menuPlacement="bottom"
                  inputRef={{
                    ...register("addKitItemSearch", {
                      onChange: (e) => {
                        if (addType === "kit") {
                          if (e.target.value?.batchno === null) {
                            getBatchWiseCssdKits(
                              getUserInfo?.loginUnitId,
                              e.target.value?.id
                            ).then((response) => {
                              setNewKitBatch(
                                response?.data?.result[0]?.kitbatchno
                              );
                              setExistKitBatch("");
                            });
                          } else {
                            setExistKitBatch(e?.target?.value?.batchno);
                            setNewKitBatch("");
                          }
                        }
                      },
                    }),
                  }}
                />
              </div>

              <CommonButton
                type="button"
                label="Add"
                className="border border-customBlue text-customBlue"
                onClick={() => {
                  if (addType === "kit") {
                    let kitBatch =
                      newKitBatch !== "" ? newKitBatch : existKitBatch;

                    let duplicateKit = cleaningKitList?.some(
                      (val) =>
                        val?.["Kit BatchNo"] === kitBatch &&
                        val?.["Item Kit Code"] === getAddKitItemSearch?.id
                    );

                    if (getAddKitItemSearch && !duplicateKit) {
                      setCleaningKitList([
                        ...cleaningKitList,
                        {
                          Select: false,
                          "Item Kit Code": getAddKitItemSearch?.id,
                          "Item Kit Name": getAddKitItemSearch?.label,
                          "Kit BatchNo":
                            newKitBatch !== "" ? newKitBatch : existKitBatch,
                          newBatch: newKitBatch !== "" ? true : false,
                          "Sr No":
                            newKitBatch !== "" ? newKitBatch : existKitBatch,
                        },
                      ]);
                      setOpenAddKitModal(false);
                      setKitCount(kitCount !== null ? kitCount + 1 : 1);
                      setValue("addKitItemSearch", null);
                      setNewKitBatch("");
                      setExistKitBatch("");
                    } else if (duplicateKit) {
                      warningAlert("Kit already exists...!");
                    } else {
                      warningAlert("Select kit to add...!");
                    }
                  }

                  if (addType === "item") {
                    let duplicateItem = cleaningKitList?.some(
                      (val) =>
                        val?.["Item Code"] === getAddKitItemSearch?.id
                    );

                    if (getAddKitItemSearch && !duplicateItem) {
                      setCleaningKitList([
                        ...cleaningKitList,
                        {
                          Select: false,
                          "Item Code": getAddKitItemSearch?.id,
                          "Item Name": getAddKitItemSearch?.label,
                        },
                      ]);
                      setOpenAddKitModal(false);
                      setValue("addKitItemSearch", null);
                    } else if (duplicateItem) {
                      warningAlert("Item already exists...!");
                    } else {
                      warningAlert("Select item to add...!");
                    }
                  }
                }}
              />

            </div>
          </Box>
        </Modal>
      )} */}

      <Dialog
        open={openModel}
        onClose={() => handleCancelDelete()}
        maxWidth="xs"
        fullWidth
      >
        <DialogTitle>Confirmation</DialogTitle>

        <DialogContent>
          Are you sure you want to delete this item?
        </DialogContent>

        <DialogActions>
          <Button color="error" variant="outlined" onClick={handleCancelDelete}>
            Cancel
          </Button>

          <Button type="button" color="success" variant="contained" onClick={handleConfirmDelete}>
            Confirm
          </Button>
        </DialogActions>
      </Dialog>

      {openKitModal && (
        <Modal open={openKitModal}>
          <Box sx={ModalStyle} className="w-[50%] h-[50%] space-y-4">

            <div className="flex justify-between">
              <label className="font-semibold">
                {addType === "kit" ? "Add New Kit" : "Add New Item"}
              </label>

              <button
                type="button"
                onClick={() => {
                  setOpenAddKitModal(false);
                  setValue("addKitItemSearch", null);
                  setSelectedKit(null);
                }}
              >
                <CloseModalIcon />
              </button>
            </div>


            <div className="flex space-x-2">

              {addType === "item" && (
                <SearchDropdown
                  control={control}
                  name="selectKitDropdown"
                  placeholder="Select Kit (Tab)"
                  dataArray={Object.entries(groupedItems).map(([kitId, items]) => ({
                    id: kitId,
                    label: items?.[0]?.KitName || `Kit ${kitId}`,
                  }))}
                  isSearchable
                  isClearable={false}
                  menuPlacement="bottom"

                  handleInputChange={(selected) => {
                    setSelectedKit(selected?.id);

                    const index = finalTabs.findIndex(tab =>
                      String(tab.kitId) === String(selected?.id)
                    );
                    if (index !== -1) setValues(index);
                  }}
                />
              )}

              <div className="w-80">
                <SearchDropdown
                  control={control}
                  searchIcon={true}
                  name="addKitItemSearch"
                  dataArray={addType === "kit" ? modalItemKitOptions : modalItemItemOptions}
                  isSearchable={true}
                  placeholder={addType === "kit" ? "Search Item Kit" : "Search Item"}
                  isClearable={true}
                  handleInputChange={handleAddKitItemChange}
                  menuPlacement="bottom"
                  inputRef={{
                    ...register("addKitItemSearch", {
                      onChange: (e) => {
                        if (addType === "kit") {
                          if (e.target.value?.batchno === null) {
                            getBatchWiseCssdKits(
                              getUserInfo?.loginUnitId,
                              e.target.value?.id
                            ).then((response) => {
                              setNewKitBatch(response?.data?.result[0]?.kitbatchno);
                              setExistKitBatch("");
                            });
                          } else {
                            setExistKitBatch(e?.target?.value?.batchno);
                            setNewKitBatch("");
                          }
                        }
                      },
                    }),
                  }}
                />
              </div>

              <CommonButton
                type="button"
                label="Add"
                className="border border-customBlue text-customBlue"
                onClick={() => {

                  // ---------- ADD KIT ----------
                  if (addType === "kit") {

                    const kitBatch = newKitBatch || existKitBatch || `KIT-${Date.now()}`;
                    const selectedItem = watch("addKitItemSearch") || {
                      id: `KIT-${Date.now()}`,
                      label: "New Kit",
                    };

                    setCleaningKitList(prev => [
                      ...prev,
                      {
                        Select: false,
                        "Item Kit Code": selectedItem.id,
                        "Item Kit Name": selectedItem.label,
                        "Kit BatchNo": kitBatch,
                        newBatch: true,
                        "Sr No": kitBatch,
                      }
                    ]);

                    reset({ addKitItemSearch: null, selectKitDropdown: null });
                    setSelectedKit(null);   // <-- clear dropdown state
                    setOpenAddKitModal(false);

                    return;
                  }

                  // ---------- ADD ITEM ----------
                  // if (addType === "item") {

                  //   const selectedItem = watch("addKitItemSearch");
                  //   const selectedDropdownKit = watch("selectKitDropdown");

                  //   if (!selectedItem?.id) return;
                  //   if (!selectedDropdownKit?.id) return;

                  //   const kitId = selectedDropdownKit.id;

                  //   const exists = groupedItems[kitId]?.some(
                  //     itm => String(itm["Item Code"]) === String(selectedItem.id)
                  //   );
                  //   if (exists) return;

                  //   setGroupedItems(prev => ({
                  //     ...prev,
                  //     [kitId]: [
                  //       ...(prev[kitId] || []),
                  //       {
                  //         Select: true,
                  //         kitId,
                  //         "Item Code": selectedItem.id,
                  //         "Item Name": selectedItem.label,
                  //         "Cleaned Qty": 1,
                  //         "Disposed Qty": 0,
                  //         "Disposed Reason": "",
                  //       }
                  //     ]
                  //   }));

                  //   const newIndex = finalTabs.findIndex(t => String(t.kitId) === String(kitId));
                  //   if (newIndex !== -1) setValues(newIndex);

                  //   // CLEAR ALL FIELDS + FORCE DROPDOWN RESET
                  //   reset({ addKitItemSearch: null, selectKitDropdown: null });
                  //   setSelectedKit(null);
                  //   setValue("addKitItemSearch", null);
                  //   setValue("selectKitDropdown", null);

                  //   // close popup
                  //   setOpenAddKitModal(false);

                  //   // Optional: focus back input next time
                  //   setTimeout(() => {
                  //     document.querySelector("input[name='addKitItemSearch']")?.focus();
                  //   }, 200);
                  // }
                  if (addType === "item") {
                    const selectedItem = watch("addKitItemSearch");
                    const selectedDropdownKit = watch("selectKitDropdown");

                    if (!selectedItem?.id) return;
                    if (!selectedDropdownKit?.id) return;

                    const kitId = selectedDropdownKit.id;

                    // ✅ GET KIT NAME FROM TABS / GROUPED DATA
                    const kitName =
                      finalTabs.find(t => String(t.kitId) === String(kitId))?.KitName ||
                      groupedItems[kitId]?.[0]?.KitName ||
                      selectedDropdownKit.label || "";

                    const exists = groupedItems[kitId]?.some(
                      itm => String(itm["Item Code"]) === String(selectedItem.id)
                    );
                    if (exists) return;

                    // ✅ ADD ITEM WITH KitName
                    setGroupedItems(prev => ({
                      ...prev,
                      [kitId]: [
                        ...(prev[kitId] || []),
                        {
                          Select: true,
                          kitId,
                          KitName: kitName,          // 🔥 ADDED
                          "Item Code": selectedItem.id,
                          "Item Name": selectedItem.label,
                          "Cleaned Qty": 1,
                          "Disposed Qty": 0,
                          "Disposed Reason": "",
                        }
                      ]
                    }));

                    // 🔄 Switch to that kit tab
                    const newIndex = finalTabs.findIndex(
                      t => String(t.kitId) === String(kitId)
                    );
                    if (newIndex !== -1) setValues(newIndex);

                    // 🧹 RESET
                    reset({ addKitItemSearch: null, selectKitDropdown: null });
                    setSelectedKit(null);
                    setOpenAddKitModal(false);
                  }
                }}
              />


            </div>
          </Box>
        </Modal>
      )}


      <ConfirmationModal
        confirmationOpen={openPostModal}
        confirmationHandleClose={() => setOpenPostModal(false)}
        // confirmationSubmitFunc={addToStockList}
        confirmationSubmitFunc={() => addToStockList(selectedProcess, formData)}
        confirmationLabel="Confirmation"
        confirmationMsg={"Are you sure want to send to wrapping CSSD items ?"}
        confirmationButtonMsg="Confirm"
      />
    </div>
  );
};

export default DecontaminationAndCleaning;